import * as React from 'react';
import React__default from 'react';
import { MediaQuery, AccordionItem, RichTextArea, Accordion, SliderCarousel, Button, Carousel, IFrame, ContentTabs, Breadcrumbs, NotificationBar as NotificationBar$1, Olapic as Olapic$1, ScrollUpButton, CartButton } from '@grandvisionhq/common';
import { getDisplayName, isString, getLocalizedValue, QueryString, compose, LocaleUtils, StringUtils, getAttrValue, getLocalizedAttrValue, sanitizeStringForUrl } from '@grandvisionhq/utils';
import { useIntl, useFeatureToggles, useDispatch, useSelector, mergeLabels } from '@grandvisionhq/state';
import { BrPageContext, BrComponentContext, BrManageContentButton, BrComponent, BrManageMenuButton, BrPage } from '@bloomreach/react-sdk';
import { FacetId, useAlgoliaConfig, AlgoliaSearch, SearchPageHeader, ConnectedProductListing } from '@grandvisionhq/search';
import * as jsonpointer from 'jsonpointer';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { isContainerItem, initialize } from '@bloomreach/spa-sdk';
import { Banner, HighlightedContentItem, HighlightedContent, RichBanner, ContentBanner, PromotionBannersItem, CategoryLinksItem, CertificatesItem, PromotionBanners, CategoryLinks, Certificates, BlogList, BlogCard, BlogHero, ExclusiveBrandsItem, ExclusiveBrands, BrandListItem, BrandList as BrandList$1, BrandListGroup, Video, FaqItem, Faq as Faq$1, HeadTags, IconList as IconList$1, UspGroup, BlogDetailHeader, BlogIntro } from '@grandvisionhq/content';
import { Heading as Heading$1, Article as Article$1, Container, Text } from '@grandvisionhq/elements';
import { ProductBlocksContainer, FeaturedProducts, Helpers, ProductCatalogBreadcrumbs, ProductPromotions, RecentlyViewedProducts as RecentlyViewedProducts$1 } from '@grandvisionhq/products';
import { FlexLayout, CookieNotification, Footer, FooterLinks, Header, SiteNav, getLocaleSwitcherMenuLabel, getLocaleSwitcherData, PageLayout } from '@grandvisionhq/layout';
import { BookAppointment } from '@grandvisionhq/forms';
import { setUserObject, WebPage } from '@grandvisionhq/analytics';
import { Actions, Selectors, State } from '@grandvisionhq/auth';
import { Utils, MyAccountMenu } from '@grandvisionhq/my-account';
import classnames from 'classnames';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

function withAnchor(Component) {
    var displayName = getDisplayName(Component);
    var WithAnchor = function (props) {
        var _a;
        var page = props.page, component = props.component;
        var preview = page.isPreview();
        var anchorId = ((_a = component === null || component === void 0 ? void 0 : component.getParameters()) !== null && _a !== void 0 ? _a : {}).anchorId;
        return anchorId && anchorId !== '' && !preview ? (React.createElement("div", { className: "anchor-wrapper", id: anchorId, style: { marginTop: '-120px', paddingTop: '120px' } },
            React.createElement(Component, __assign({}, props)))) : (React.createElement(Component, __assign({}, props)));
    };
    WithAnchor.displayName = "withAnchor(" + displayName + ")";
    return WithAnchor;
}

var initialValue = Object.freeze({
    cmsUrls: { live: '', preview: '' },
    componentDefinitions: {},
    preview: false,
    pageModel: undefined,
    path: '',
    excludeSkuFromProductUrls: false,
    disableUrlRewriter: false,
    siteLogos: {
        main: '',
        small: '',
        mobile: '',
        alternative: '',
        reimbursable: '',
        reimbursableAlternative: '',
    },
});
var VISITOR_COOKIE = '_visitor';
/**
 * Note: do not use BloomreachContext.Provider directly. Instead, import {
 * BloomreachProvider } from './BloomreachProvider'. It's in a separate module
 * to avoid a circular dependency between ../component-definitions and
 * ../containers.
 */
var BloomreachContext = React.createContext(initialValue);
function useBloomreach() {
    return React.useContext(BloomreachContext);
}
/**
 * Wrap Contexts from BR SDK in a hook so they're easier to mock in tests
 */
function useBrPageContext() {
    return React.useContext(BrPageContext);
}
function useBrComponentContext() {
    return React.useContext(BrComponentContext);
}

/**
 * Creates an apiUrl that supports multilingual.
 * Don't pass locale for non-multilingual sites.
 * For multilingual it should be: [baseUrl]/en_GB/resourceapi/[path]
 * By default it should be: [baseUrl]/resourceapi/[path]
 */
function createBloomreachApiUrl(baseUrl, locale) {
    if (locale !== undefined) {
        return baseUrl + "/" + locale.replace('-', '_');
    }
    return baseUrl;
}

function getUrl(url, page, disableUrlRewriter) {
    if (disableUrlRewriter === void 0) { disableUrlRewriter = false; }
    // Check wether all settings are defined and correct and check if the link is relative
    // (absolute urls are usually external and don't need to be parsed by the bloomreach SDK)
    if (url && page && disableUrlRewriter && page.isPreview() && /^\/[a-zA-Z0-9_].*/.test(url)) {
        return page.getUrl(url);
    }
    return url;
}

function createMenu(_a, page, disableUrlRewriter) {
    var _b = _a === void 0 ? {} : _a, menu = _b.menu;
    if (!menu || !menu.siteMenuItems.length) {
        return [];
    }
    return mapToMenu(menu.siteMenuItems, page, disableUrlRewriter);
}
function mapToMenu(items, page, disableUrlRewriter) {
    return items.map(function (item) {
        var _a;
        var link = item._links.site;
        var menuItem = {
            label: item.name,
            link: __assign(__assign({}, link), { href: (_a = parseHref(link, page, disableUrlRewriter)) !== null && _a !== void 0 ? _a : '', type: (link === null || link === void 0 ? void 0 : link.type) === 'internal' ? 'internal' : 'external' }),
        };
        if (item.parameters && Object.keys(item.parameters).length > 0) {
            menuItem.parameters = item.parameters;
        }
        if (item.childMenuItems && item.childMenuItems.length > 0) {
            menuItem.childMenuItems = mapToMenu(item.childMenuItems, page, disableUrlRewriter);
        }
        return menuItem;
    });
}
function parseHref(link, page, disableUrlRewriter) {
    if (link && page) {
        return getUrl(link.href, page, disableUrlRewriter);
    }
}

/**
 * Locale needs to be omitted from the path for multilingual sites
 * For non-multilingual sites, make sure locale is not passed
 */
function createPath(path, locale) {
    if (locale === undefined) {
        return path;
    }
    var localePath = "/" + locale.replace('-', '_');
    // If the path is exactly equal to the localePath (e.g. home page request)
    // We need to return a / so we don't return an empty string
    if (path === localePath) {
        return '/';
    }
    return path.includes(localePath) ? path.replace(localePath, '') : path;
}

/**
 * Creates CMS resource url for Bloomreach
 * Locale should be formatted with an underscore like: "en_GB"
 */
function createBloomreachResourceUrl(baseUrl, channel, resourceIds, locale) {
    if (!baseUrl || !channel) {
        throw new Error("Failed to create Bloomreach CMS resource url. Need valid baseUrl and channel but got baseUrl: " + String(baseUrl) + " and channel: " + channel + " }");
    }
    var localePath = locale ? "/" + locale.replace('-', '_') : '';
    var queryParam = "?resourceBundleIds=" + encodeURIComponent(resourceIds.join(','));
    /**
     * If the base URL contains a channel and the "channel" argument exactly
     * matches that, the channel will be moved from after the base URL to the
     * end of the URL, before the query params.
     */
    var url = baseUrl.includes(channel) ? baseUrl.replace("/" + channel, '') : baseUrl;
    return url + '/api/resources' + localePath + ("/" + channel) + queryParam;
}

/**
 * Converts default JSON structure of bloomreach resource API to flat format:
 * { [key: string (e.g. products)]: Object<key:value> }
 */
function flattenResources(resources) {
    var _a;
    var bundles = ((_a = resources === null || resources === void 0 ? void 0 : resources.resourceBundles) !== null && _a !== void 0 ? _a : {}).bundles;
    var flatBundles = {};
    for (var key in bundles) {
        if (bundles.hasOwnProperty(key)) {
            // get last part of key to create a shorter key in the new object
            var newKey = key.split('.')[key.split('.').length - 1];
            var _b = bundles[key].properties, properties = _b === void 0 ? {} : _b;
            flatBundles[newKey] = properties;
        }
    }
    return flatBundles;
}

function getComponentByPath(path, pageModel) {
    var _a;
    var componentNames = path.split('/');
    if (!(pageModel === null || pageModel === void 0 ? void 0 : pageModel.page) || !componentNames) {
        return;
    }
    var component = pageModel.page;
    var _loop_1 = function () {
        var name_1 = componentNames.shift();
        component = (_a = component === null || component === void 0 ? void 0 : component.components) === null || _a === void 0 ? void 0 : _a.find(function (c) { return c.name === name_1; });
    };
    while (componentNames.length && component) {
        _loop_1();
    }
    return component;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getContentByRef(ref, pageModel) {
    if (!ref || !pageModel) {
        return undefined;
    }
    return jsonpointer.get(pageModel, ref);
}

/**
 * This function is only used in opco sites to configure Algolia on the server.
 */
function getAlgoliaConfigFromBloomreach(pageModel) {
    var _a, _b, _c, _d;
    if (!pageModel) {
        return {
            isEnabled: false,
        };
    }
    var container = getComponentByPath('main/container', pageModel);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var component = (_a = container === null || container === void 0 ? void 0 : container.components) === null || _a === void 0 ? void 0 : _a.find(function (c) { return c.label === 'Product catalog v2'; });
    var content = getContentByRef((_c = (_b = component === null || component === void 0 ? void 0 : component.models) === null || _b === void 0 ? void 0 : _b.document) === null || _c === void 0 ? void 0 : _c.$ref, pageModel);
    var isEnabled = !!component;
    var presetQueryString = getPresetQueryString(content);
    var ruleContexts = (_d = content === null || content === void 0 ? void 0 : content.ruleContexts) !== null && _d !== void 0 ? _d : [];
    var isPrescriptionGlasses = presetQueryString.toLowerCase().includes('frames') ||
        presetQueryString.toLowerCase().includes('sunglasses');
    var facetingAfterDistinct = !isPrescriptionGlasses;
    return {
        isEnabled: isEnabled,
        presetQueryString: presetQueryString,
        ruleContexts: ruleContexts,
        facetingAfterDistinct: facetingAfterDistinct,
    };
}
function getPresetQueryString(content) {
    if (!content) {
        return '';
    }
    var presetQueryString = (content.filterQuery || '').split('#')[0];
    var categoryExternalId = content.categoryExternalId || '';
    if (categoryExternalId) {
        var symbol = presetQueryString.includes('?') ? '&' : '?';
        presetQueryString += symbol + (FacetId.categoryExternalId + "=" + categoryExternalId);
    }
    return presetQueryString;
}

function getPageTemplate(pageModel, mapping) {
    var _a, _b;
    if (!pageModel || !pageModel.page || !mapping) {
        return '/_error';
    }
    // PageId is more specific, so use that if that's available
    var id = (_a = pageModel.page.models) === null || _a === void 0 ? void 0 : _a.pageId;
    var type = (_b = pageModel.page.models) === null || _b === void 0 ? void 0 : _b.pageType;
    if (!id && !type) {
        return '/_error';
    }
    if (id === 'pagenotfound' || type === 'pagenotfound') {
        return '/404';
    }
    return mapping[id] || mapping[type] || '/_error';
}

function getConfiguratorDocument(configuratorDocumentRef, pageModel, noAddonsImage) {
    var _a;
    if (!pageModel) {
        return undefined;
    }
    var _b = (_a = getContentByRef(configuratorDocumentRef === null || configuratorDocumentRef === void 0 ? void 0 : configuratorDocumentRef.$ref, pageModel)) !== null && _a !== void 0 ? _a : {}, prescriptionStepDescription = _b.prescriptionStepDescription, prescriptionStepImage = _b.prescriptionStepImage;
    var rxDescription = prescriptionStepDescription
        ? prescriptionStepDescription.value
        : undefined;
    var rxImage = prescriptionStepImage ? prescriptionStepImage : undefined;
    return {
        prescriptionStep: {
            description: rxDescription,
            image: rxImage,
        },
        addOnsStep: {
            noAddonsImage: noAddonsImage,
        },
    };
}

// There are 4 locations in the pageModel where a SEO config can be added
// For content pages it's always in the default "main/seo" path
var seoLocations = [
    'main/seo',
    'main/container/seo',
    'main/top-container/seo',
    'main/bottom-container/seo',
];
function getPageSeo(pageModel) {
    var e_1, _a;
    if (!pageModel) {
        return undefined;
    }
    var seo;
    try {
        // Look for the first path we can find that contains a SEO component
        for (var seoLocations_1 = __values(seoLocations), seoLocations_1_1 = seoLocations_1.next(); !seoLocations_1_1.done; seoLocations_1_1 = seoLocations_1.next()) {
            var path = seoLocations_1_1.value;
            var comp = getComponentByPath(path, pageModel);
            if (comp === null || comp === void 0 ? void 0 : comp.models) {
                seo = comp.models.seoData;
                break;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (seoLocations_1_1 && !seoLocations_1_1.done && (_a = seoLocations_1.return)) _a.call(seoLocations_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return seo;
}

function getPlpPromotionSize(pageModel, breakpoint) {
    var _a, _b, _c, _d;
    if (!pageModel) {
        return {};
    }
    var mainComponent = getComponentByPath('main', pageModel);
    var catalogComponent = (_b = (_a = mainComponent === null || mainComponent === void 0 ? void 0 : mainComponent.components) === null || _a === void 0 ? void 0 : _a[0].components) === null || _b === void 0 ? void 0 : _b.find(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (c) { return c.label === 'Product catalog v2'; });
    if (!catalogComponent) {
        return {};
    }
    var ref = (_d = (_c = catalogComponent.models) === null || _c === void 0 ? void 0 : _c.document) === null || _d === void 0 ? void 0 : _d.$ref;
    var content = getContentByRef(ref, pageModel);
    var _e = content !== null && content !== void 0 ? content : {}, smallPromotion = _e.smallPromotion, bigPromotion = _e.bigPromotion;
    var isSmallScreen = breakpoint === MediaQuery.BreakpointName.PHONE;
    var smallPromoSize = smallPromotion ? (isSmallScreen ? 2 : 1) : 0;
    var bigPromoSize = bigPromotion ? 2 : 0;
    return { plpPromotionSize: smallPromoSize + bigPromoSize };
}

function parseBloomreachImage(image) {
    var _a, _b, _c, _d, _e;
    if (!image) {
        return undefined;
    }
    return {
        alt: (_a = image.description) !== null && _a !== void 0 ? _a : '',
        original: {
            alt: (_b = image.description) !== null && _b !== void 0 ? _b : '',
            url: ((_c = image.original) === null || _c === void 0 ? void 0 : _c.url) || '',
            dimensions: getDimensions(image.original),
        },
        mobile: {
            alt: (_d = image.description) !== null && _d !== void 0 ? _d : '',
            url: ((_e = image.mobile) === null || _e === void 0 ? void 0 : _e.url) || '',
            dimensions: getDimensions(image.mobile),
        },
    };
}
function getDimensions(input) {
    return { w: (input === null || input === void 0 ? void 0 : input.width) || 0, h: (input === null || input === void 0 ? void 0 : input.height) || 0 };
}

function parseBloomreachInputField(inputField) {
    return inputField
        ? {
            placeholder: inputField.placeholder,
            id: inputField.inputId,
            type: inputField.type || 'text',
        }
        : undefined;
}

var nonLetterGroupTitle = '#';
// Replace with /^p{L}/u once IE11 support is dropped
var startsWithLetter = /^[a-zA-ZÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜŸäëïöüŸçÇŒœßØøÅåÆæÞþÐð]/i;
var groupTitle = function (title) {
    return startsWithLetter.test(title) ? title === null || title === void 0 ? void 0 : title.charAt(0).toUpperCase() : nonLetterGroupTitle;
};
var groupBrands = function (items, maxGroupLength, locale) {
    if (maxGroupLength === void 0) { maxGroupLength = 4; }
    if (!items) {
        return [];
    }
    var currentTitle;
    return items
        .sort(function (a, b) {
        var aLetter = startsWithLetter.test(a.title);
        var bLetter = startsWithLetter.test(b.title);
        return aLetter && !bLetter
            ? 1
            : !aLetter && bLetter
                ? -1
                : a.title.localeCompare(b.title, locale, {
                    sensitivity: 'base',
                    usage: 'sort',
                    numeric: true,
                });
    })
        .reduce(function (result, item) {
        var title = groupTitle(item.title);
        var currentGroup = result[result.length - 1];
        if (title !== currentTitle) {
            currentTitle = title;
            currentGroup = { title: title, items: [] };
            result.push(currentGroup);
        }
        if (currentGroup.items.length === maxGroupLength) {
            currentGroup = { title: '', items: [] };
            result.push(currentGroup);
        }
        currentGroup.items.push(item);
        return result;
    }, []);
};

/**
 * We need this function to make sure we can set the BrPageModel type
 * because the toJSON function from the SDK has return type of "object".
 * This function will no longer be required when this is fixed in the SDK.
 */
function parsePageModel(page) {
    var pageModel = (page === null || page === void 0 ? void 0 : page.toJSON()) || {};
    return pageModel;
}

function brHttpClient(_a) {
    var url = _a.url, data = _a.data, rest = __rest(_a, ["url", "data"]);
    return fetch(url, __assign(__assign({}, rest), { body: data })).then(function (r) { return r.json().then(function (j) { return ({ data: j }); }); });
}

// This is the key that BR uses to set the hidden property on a container component
var PARAMETER_HIDDEN = 'com.onehippo.cms7.targeting.TargetingParameterUtil.hide';
// Default properties on bloomreach content and meta objects
// that are always there, but we don't require on component level
var omitKeysContent = ['displayName', 'versionedNode', '_links', 'localeString', 'type'];
var omitKeysMeta = [PARAMETER_HIDDEN, 'document', 'mobile', 'tablet', 'desktop'];
function parseBloomreachContent(content) {
    if (content === void 0) { content = {}; }
    return Object.keys(content).reduce(function (result, key) {
        var _a;
        return (omitKeysContent.includes(key) ? result : __assign(__assign({}, result), (_a = {}, _a[key] = content[key], _a)));
    }, {});
}
function parseBloomreachMeta(meta) {
    return Object.keys(meta).reduce(function (result, key) {
        var _a;
        return (omitKeysMeta.includes(key) ? result : __assign(__assign({}, result), (_a = {}, _a[key] = meta[key], _a)));
    }, {});
}
var getCommonParams = function (_a) {
    var title = _a.title, theme = _a.theme, template = _a.template;
    return (__assign(__assign(__assign({}, (isString(title) ? { title: title } : {})), (isString(theme) ? { theme: theme } : {})), (isString(template) ? { template: template } : {})));
};
function fetchPagedComponent(url, componentId, pageIndex, path) {
    if (pageIndex === void 0) { pageIndex = 1; }
    if (path === void 0) { path = '/blog'; }
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url + "/resourceapi" + path + "?_hn%3Atype=component-rendering&_hn%3Aref=" + componentId + "&page=" + pageIndex, {
                        method: 'GET',
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.json()];
            }
        });
    });
}

function parseBloomreachArticles(pageable, highlighted, pageModel) {
    var _a = pageable !== null && pageable !== void 0 ? pageable : {}, currentPage = _a.currentPage, nextPage = _a.nextPage, endPage = _a.endPage, items = _a.items;
    var highlightedContent = highlighted && getContentByRef(highlighted.$ref, pageModel);
    var articles = items.map(function (item) { return item && getContentByRef(item.$ref, pageModel); });
    return {
        highlighted: highlightedContent,
        paged: {
            items: articles,
            currentPage: currentPage,
            nextPage: nextPage,
            endPage: endPage,
        },
    };
}
var useBloomreachArticles = function (_a) {
    var component = _a.component, page = _a.page;
    var cmsUrls = useBloomreach().cmsUrls;
    var locale = useIntl().locale;
    var isMultilingualEnabled = useFeatureToggles().isMultilingualEnabled;
    var componentId = component.getId();
    var pageModel = page.toJSON();
    var localeTransformed = locale.replace('-', '_');
    var url = isMultilingualEnabled ? (cmsUrls === null || cmsUrls === void 0 ? void 0 : cmsUrls.live) + "/" + localeTransformed : cmsUrls.live;
    var _b = component.getModels(), pageable = _b.pageable, highlightedArticle = _b.highlightedArticle;
    var _c = __read(React.useState(1), 2), currentPage = _c[0], setCurrentPage = _c[1];
    var _d = __read(React.useState(false), 2), loading = _d[0], setLoading = _d[1];
    var _e = __read(React.useState(), 2), error = _e[0], setError = _e[1];
    var _f = __read(React.useState(function () {
        return parseBloomreachArticles(pageable, highlightedArticle, pageModel);
    }), 2), result = _f[0], setResult = _f[1];
    var loadNextPage = React.useCallback(function () {
        result.paged.nextPage && setCurrentPage(result.paged.nextPage);
    }, [result.paged.nextPage]);
    React.useEffect(function () {
        if (currentPage === result.paged.currentPage) {
            return;
        }
        var path = isMultilingualEnabled
            ? window === null || window === void 0 ? void 0 : window.location.pathname.replace("/" + localeTransformed, '')
            : window === null || window === void 0 ? void 0 : window.location.pathname;
        var current = true;
        setLoading(true);
        fetchPagedComponent(url, componentId, currentPage, path)
            .then(function (res) {
            var _a;
            if (current) {
                if ((_a = res === null || res === void 0 ? void 0 : res.page) === null || _a === void 0 ? void 0 : _a.models) {
                    var _b = res.page.models, pageable_1 = _b.pageable, highlightedArticle_1 = _b.highlightedArticle;
                    var paged_1 = parseBloomreachArticles(pageable_1, highlightedArticle_1, res).paged;
                    setResult(function (state) { return (__assign(__assign({}, state), { paged: __assign(__assign({}, paged_1), { items: __spreadArray(__spreadArray([], __read(state.paged.items)), __read(paged_1.items)) }) })); });
                }
                setLoading(false);
            }
        })
            .catch(function (err) {
            if (current) {
                console.error(err);
                setError(err);
                setLoading(false);
            }
        });
        return function () {
            current = false;
        };
    }, [
        cmsUrls,
        currentPage,
        result.paged.currentPage,
        page,
        componentId,
        url,
        isMultilingualEnabled,
        localeTransformed,
    ]);
    return { loading: loading, error: error, result: result, loadNextPage: loadNextPage };
};

/**
 * Receives a configuration for a Bloomreach container component
 * and maps it to our own CmsComponentData model
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useBloomreachData(_a) {
    var page = _a.page, component = _a.component;
    var documentRef = component.getModels().document;
    var document = documentRef && page.getContent(documentRef);
    var content = __assign(__assign({}, (page.isPreview() ? { document: document } : {})), parseBloomreachContent(document === null || document === void 0 ? void 0 : document.getData()));
    var meta = parseBloomreachMeta(component.getParameters());
    var common = getCommonParams(meta);
    return {
        ref: documentRef === null || documentRef === void 0 ? void 0 : documentRef.$ref,
        data: __assign({ meta: meta, content: content }, common),
    };
}

function useBloomreachLinks(links) {
    if (links === void 0) { links = []; }
    var disableUrlRewriter = useBloomreach().disableUrlRewriter;
    var page = useBrPageContext();
    return links.map(function (_a) {
        var _b;
        var url = _a.url, label = _a.label, style = _a.style, openInNewWindow = _a.openInNewWindow;
        return ({
            label: label,
            style: style,
            url: (_b = getUrl(url, page, disableUrlRewriter)) !== null && _b !== void 0 ? _b : '',
            target: openInNewWindow ? 'external' : 'internal',
        });
    });
}

function useBloomreachPageRoutes() {
    var _a, _b;
    var _c = useBloomreach(), pageModel = _c.pageModel, preview = _c.preview, disableUrlRewriter = _c.disableUrlRewriter;
    if (!((_b = (_a = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page) === null || _a === void 0 ? void 0 : _a.models) === null || _b === void 0 ? void 0 : _b.routes)) {
        return { routes: {} };
    }
    var routes = pageModel.page.models.routes;
    // In the new version of bloomreach in preview mode the params that
    // are added by the bloomreach API can cause issues for the root routes sometimes
    // because these are base routes that are usually joined with other paths
    var cleanedRoutes = routes;
    if (preview && disableUrlRewriter) {
        cleanedRoutes = Object.keys(routes).reduce(function (acc, key) {
            var _a;
            var route = routes[key].split('?')[0];
            return __assign(__assign({}, acc), (_a = {}, _a[key] = route !== null && route !== void 0 ? route : '', _a));
        }, {});
    }
    return { routes: cleanedRoutes };
}

function useBloomreachPageable(_a) {
    var page = _a.page, component = _a.component;
    var pageable = component.getModels().pageable;
    if (!pageable || !pageable.items) {
        return {
            refs: pageable === null || pageable === void 0 ? void 0 : pageable.items,
            data: {
                meta: {},
                content: { items: [] },
            },
        };
    }
    var documents = pageable.items.map(function (ref) { return page.getContent(ref); });
    var items = documents.map(function (doc) { return (__assign(__assign({}, (page.isPreview() ? { document: doc } : {})), parseBloomreachContent(doc === null || doc === void 0 ? void 0 : doc.getData()))); });
    var meta = parseBloomreachMeta(component.getParameters());
    var commonParams = getCommonParams(meta);
    return {
        refs: pageable.items,
        data: __assign({ meta: meta, content: { items: items } }, commonParams),
    };
}

var emptyContent = {};
function useBloomreachPdpContent() {
    var _a, _b, _c, _d, _e;
    var pageModel = useBloomreach().pageModel;
    if (!((_a = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page) === null || _a === void 0 ? void 0 : _a.models)) {
        return emptyContent;
    }
    var mainComponent = getComponentByPath('main', pageModel);
    var ref = (_b = mainComponent === null || mainComponent === void 0 ? void 0 : mainComponent.models) === null || _b === void 0 ? void 0 : _b.document.$ref;
    var content = getContentByRef(ref, pageModel);
    if (!content) {
        console.warn("Cannot find main content for ProductDetail pageModel. Got: " + content + " for $ref: " + ref);
        return emptyContent;
    }
    var usps = content.usps, instructions = content.instructions, packshotTypes = content.packshotTypes, noAddonsImage = content.noAddonsImage, additionalUsps = content.additionalUsps, disclaimer = content.disclaimer, configuratorDocumentRef = content.configuratorDocument;
    var configuratorDocument = getConfiguratorDocument(configuratorDocumentRef, pageModel, noAddonsImage);
    var modal = getModalContent(mainComponent, pageModel);
    var vtoBanner = getContentByRef((_c = content.vtoBanner) === null || _c === void 0 ? void 0 : _c.$ref, pageModel);
    return {
        packshotTypes: packshotTypes,
        modalContent: (_e = (_d = modal === null || modal === void 0 ? void 0 : modal.content) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : '',
        instructions: instructions && {
            id: instructions.id,
            value: instructions.html,
            textColor: instructions.textColor,
            backgroundColor: instructions.backgroundColor,
        },
        usps: usps.map(function (_a) {
            var icon = _a.icon, text = _a.text;
            return ({ icon: icon, text: text });
        }),
        additionalUsps: additionalUsps.map(function (_a) {
            var icon = _a.icon, text = _a.text;
            return ({ icon: icon, text: text });
        }),
        configuratorDocument: configuratorDocument,
        vtoBanner: vtoBanner,
        disclaimer: disclaimer,
    };
}
function getModalContent(main, pageModel) {
    var _a, _b;
    var components = (_a = main === null || main === void 0 ? void 0 : main.components) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, cur) {
        return (cur === null || cur === void 0 ? void 0 : cur.components) ? __spreadArray(__spreadArray([], __read(acc)), __read(cur === null || cur === void 0 ? void 0 : cur.components)) : acc;
    }, []);
    var modal = (components || []).find(function (c) { var _a, _b; return c.name === 'richtext' && ((_b = (_a = c._meta) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.template) === 'modal'; });
    return modal && getContentByRef((_b = modal === null || modal === void 0 ? void 0 : modal.models) === null || _b === void 0 ? void 0 : _b.document.$ref, pageModel);
}

function useBloomreachProductRoutes() {
    var _a, _b, _c, _d;
    var locale = useIntl().locale;
    var _e = useBloomreach(), pageModel = _e.pageModel, excludeSkuFromProductUrls = _e.excludeSkuFromProductUrls, disableUrlRewriter = _e.disableUrlRewriter;
    var page = useBrPageContext();
    var productRoutes = (_c = (_b = (_a = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page) === null || _a === void 0 ? void 0 : _a.models) === null || _b === void 0 ? void 0 : _b.productRoutes) !== null && _c !== void 0 ? _c : {};
    var hasRoutes = productRoutes && Object.keys(productRoutes).length > 0;
    if (!hasRoutes) {
        console.log("Could not get productRoutes for page with name " + ((_d = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page) === null || _d === void 0 ? void 0 : _d.name) + ", got: " + String(productRoutes));
    }
    var sortedProductRoutes = hasRoutes
        ? Object.entries(productRoutes).reduce(function (acc, _a, i) {
            var _b = __read(_a, 2), productType = _b[0], route = _b[1];
            // TODO: remove when BR pageModel is updated
            // Skip legacy implementation key
            if (productType === '$ref') {
                return acc;
            }
            acc.byProductType[productType] = route;
            acc.checksum = acc.checksum + "|" + i + "-" + productType + ":" + route;
            return acc;
        }, { byProductType: {}, checksum: '' })
        : null;
    var formatProductUrl = React.useCallback(function (product, additionalQueryParams) {
        if (additionalQueryParams === void 0) { additionalQueryParams = {}; }
        if (!CommerceToolsApi.isProductTypeName(product.productType) || !sortedProductRoutes) {
            return '#';
        }
        var targetPath = sortedProductRoutes.byProductType[product.productType];
        if (!targetPath) {
            console.warn("No targetPath (root of url) found to format product url for productType " + product.productType + ", got targetPath: " + String(targetPath));
            return '';
        }
        var _a = __read(targetPath.split('?'), 2), path = _a[0], query = _a[1];
        var slug = getLocalizedValue(product.slug, locale);
        var sku = !!product.sku && !excludeSkuFromProductUrls ? "/" + product.sku : '';
        // Merge original query from url with any additionalQueryParams that were passed
        var allQueryParams = __assign(__assign({}, (Boolean(query) ? QueryString.parse(query) : {})), additionalQueryParams);
        var queryString = Object.keys(allQueryParams).length > 0 ? QueryString.stringify(allQueryParams) : '';
        var productUrl = path + "/" + slug + sku + queryString;
        return disableUrlRewriter && (page === null || page === void 0 ? void 0 : page.isPreview()) ? page === null || page === void 0 ? void 0 : page.getUrl(productUrl) : productUrl;
    }, [sortedProductRoutes, locale, excludeSkuFromProductUrls, disableUrlRewriter, page]);
    // Omit a $ref from the productRoutes object
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    productRoutes.$ref; var routes = __rest(productRoutes, ["$ref"]);
    return React.useMemo(function () { return [{ hasRoutes: hasRoutes }, { formatProductUrl: formatProductUrl }, routes]; }, [
        hasRoutes,
        formatProductUrl,
        routes,
    ]);
}

function useBloomreachRichText(html) {
    var disableUrlRewriter = useBloomreach().disableUrlRewriter;
    var page = useBrPageContext();
    if (html) {
        return html.replace(/<a href="([^"]*)"/g, function (_, $1) {
            return "<a href=\"" + getUrl($1, page, disableUrlRewriter) + "\"";
        });
    }
    return '';
}

/**
 * List of breakpoint names supported by Bloomreach. By using this list, components will always be visible
 * in any new breakpoint by default (no option to hide them until Bloomreach supports the new breakpoint)
 * If a breakpoint ever gets removed/replaced in the original enum, Bloomreach needs to be updated first to support the change
 */
var supportedBreakpoints = [
    MediaQuery.BreakpointName.PHONE,
    MediaQuery.BreakpointName.TABLET_PORTRAIT,
    MediaQuery.BreakpointName.TABLET_LANDSCAPE,
    MediaQuery.BreakpointName.DESKTOP,
];
var isComponentVisible = function (breakpoint, visibility) {
    return !visibility || !supportedBreakpoints.includes(breakpoint) || visibility.includes(breakpoint);
};
function useBreakpointVisibility(_a) {
    var component = _a.component, page = _a.page;
    var breakpoint = MediaQuery.useBreakpoint();
    var preview = page.isPreview();
    var visibility = (component === null || component === void 0 ? void 0 : component.getModels()).visibility;
    return preview || isComponentVisible(breakpoint, visibility);
}

var useBloomreachSdpContent = function () {
    var _a, _b, _c;
    var pageModel = useBloomreach().pageModel;
    if (!((_a = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page) === null || _a === void 0 ? void 0 : _a.models)) {
        return {};
    }
    var mainComponent = getComponentByPath('main', pageModel);
    var ref = (_c = (_b = mainComponent === null || mainComponent === void 0 ? void 0 : mainComponent.models) === null || _b === void 0 ? void 0 : _b.storeDetailDocument) === null || _c === void 0 ? void 0 : _c.$ref;
    var content = getContentByRef(ref, pageModel);
    if (!content) {
        console.warn("Cannot find main content for StoreDetailPage pageModel. Got: " + content + " for $ref: " + ref);
        return {};
    }
    var storeFallbackImage = content.storeFallbackImage, paymentIcons = content.paymentIcons, socialMediaIcons = content.socialMediaIcons;
    return { storeFallbackImage: storeFallbackImage === null || storeFallbackImage === void 0 ? void 0 : storeFallbackImage.url, paymentIcons: paymentIcons, socialMediaIcons: socialMediaIcons };
};

function withBloomreachData(Component) {
    var displayName = getDisplayName(Component);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var WithBloomreachData = function (props) {
        var _a = useBloomreachData(props), ref = _a.ref, data = _a.data;
        if (!data || !data.content) {
            console.error("Tried to render CmsComponent " + displayName + " without content object with ref: " + ref);
            return React.createElement(Component, __assign({}, props));
        }
        return React.createElement(Component, __assign({}, data, props));
    };
    WithBloomreachData.displayName = "WithBloomreachData(" + displayName + ")";
    return WithBloomreachData;
}

function withBloomreachPageable(Component) {
    var displayName = getDisplayName(Component);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var WithBloomreachPageable = function (props) {
        var _a;
        var _b = useBloomreachPageable(props), refs = _b.refs, data = _b.data;
        if (!((_a = data.content.items) === null || _a === void 0 ? void 0 : _a.length)) {
            console.warn("Trying to render Bloomreach pageable component: " + displayName + ", but found no content documents. Refs: " + refs);
            return React.createElement(Component, __assign({}, props, { content: { items: [] } }));
        }
        return React.createElement(Component, __assign({}, data, props));
    };
    WithBloomreachPageable.displayName = "WithBloomreachPageable(" + displayName + ")";
    return WithBloomreachPageable;
}

function withBreakpointVisibility(Component) {
    var displayName = getDisplayName(Component);
    var WithBreakpointVisibility = function (props) {
        return useBreakpointVisibility(props) ? React.createElement(Component, __assign({}, props)) : null;
    };
    WithBreakpointVisibility.displayName = "WithBreakpointVisibility(" + displayName + ")";
    return WithBreakpointVisibility;
}

/**
 * This HoC requires the passed component to have a content object on its props
 * This means when used in combination with withBloomreachData hoc, this hoc should come after
 *  compose(withBloomreachData, withEditableContent)
 */
function withEditableContent(Component) {
    var displayName = getDisplayName(Component);
    var WithEditableContent = function (props) {
        if (!props.content || !props.content.document) {
            return React.createElement(Component, __assign({}, props));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { position: 'relative' } },
                React.createElement(BrManageContentButton, { content: props.content.document })),
            React.createElement(Component, __assign({}, props))));
    };
    WithEditableContent.displayName = "WithEditableContent(" + displayName + ")";
    return WithEditableContent;
}

/**
 * With this HoC, CmsContainers can be hidden by content editors
 * for specific audiences using Br's relevance module.
 * Only works for Bloomreach components of type CONTAINER_ITEM_COMPONENT
 */
function withHidableContent(Component) {
    var displayName = getDisplayName(Component);
    var WithHidableContent = function (props) {
        var _a = props || {}, component = _a.component, page = _a.page;
        var preview = page === null || page === void 0 ? void 0 : page.isPreview();
        var hidden = component && isContainerItem(component) ? component.isHidden() : false;
        // A Cms component should always be shown in preview mode
        if (hidden && !preview) {
            return null;
        }
        return React.createElement(Component, __assign({}, props));
    };
    WithHidableContent.displayName = "withHidableContent(" + displayName + ")";
    return WithHidableContent;
}

var CmsAccordionItem = withEditableContent(function (_a) {
    var _b;
    var content = _a.content, expanded = _a.expanded, headingLevel = _a.headingLevel;
    var richText = useBloomreachRichText((_b = content.content) === null || _b === void 0 ? void 0 : _b.value);
    return (React.createElement(AccordionItem, { id: content.id, label: content.title, expanded: expanded, headingLevel: headingLevel },
        React.createElement(RichTextArea, { content: richText })));
});
var CmsAccordion = function (_a) {
    var headingLevel = _a.headingLevel, meta = _a.meta, content = _a.content;
    return (React.createElement(Accordion, null, content.items.map(function (item, i) { return (React.createElement(CmsAccordionItem, { key: item.id, content: item, headingLevel: headingLevel, expanded: meta.expandedByDefault === "" + (i + 1) })); })));
};
var CmsAccordion$1 = compose(withBreakpointVisibility, withHidableContent, withBloomreachPageable, withAnchor)(CmsAccordion);

var CmsArticle = function (_a) {
    var _b;
    var component = _a.component;
    var article = component.getModels().document;
    var template = component.getParameters().template;
    var image = parseBloomreachImage(article === null || article === void 0 ? void 0 : article.image);
    var _c = __read(useBloomreachLinks([{ url: (_b = article === null || article === void 0 ? void 0 : article.url) !== null && _b !== void 0 ? _b : '#' }]), 1), link = _c[0];
    if (!article) {
        return null;
    }
    switch (template) {
        case 'article-banner-preview':
            return (React.createElement(Article$1, null, image && (React.createElement(Banner, { useContainer: true, image: image.original, mobileImage: image.mobile, link: link }))));
        default:
            return React.createElement(Heading$1, { variant: "subheading1" }, "Unsupported article template " + template);
    }
};
var Article = compose(withAnchor, withBreakpointVisibility)(CmsArticle);

var CmsArticleCollectionItem = withEditableContent(function (_a) {
    var content = _a.content;
    var coverImage = content.coverImage, url = content.url, title = content.title, summary = content.summary;
    var _b = __read(useBloomreachLinks([{ url: url !== null && url !== void 0 ? url : '#' }]), 1), link = _b[0];
    var image = parseBloomreachImage(coverImage);
    if (!image) {
        console.error('Missing coverImage');
        return null;
    }
    return React.createElement(HighlightedContentItem, { image: image.original, text: summary, title: title, link: link });
});
var CmsArticleCollection = function (_a) {
    var content = _a.content;
    return (React.createElement(HighlightedContent, null, content.items.map(function (item) { return (React.createElement(CmsArticleCollectionItem, { key: item.id, content: item })); })));
};
var CmsArticleCollection$1 = compose(withBreakpointVisibility, withHidableContent, withBloomreachPageable, withEditableContent, withAnchor)(CmsArticleCollection);

/**
 * The RuntimeContext is deprecated and will be removed in the future as it's too generic,
 * we should supply props trough more specific contexts.
 *
 * Please do not add this component in any new components outside this package or extend the current model
 */
var RuntimeContext = React.createContext({});

var CmsBanner = function (_a) {
    var _b;
    var content = _a.content, template = _a.template, meta = _a.meta;
    var title = content.title, description = content.description, richText = content.content;
    var siteLogos = useBloomreach().siteLogos;
    var _c = __read(useBloomreachProductRoutes(), 2); _c[0]; var formatProductUrl = _c[1].formatProductUrl;
    var grandvision = React.useContext(RuntimeContext).grandvision;
    var links = useBloomreachLinks(content.links);
    var image = parseBloomreachImage(content.image);
    switch (template) {
        case 'full-width':
            return React.createElement(Banner, { image: image === null || image === void 0 ? void 0 : image.original, mobileImage: image === null || image === void 0 ? void 0 : image.mobile, link: links[0] });
        case 'contained-banner':
            return (React.createElement(Banner, { image: image === null || image === void 0 ? void 0 : image.original, mobileImage: image === null || image === void 0 ? void 0 : image.mobile, link: links[0], useContainer: true }));
        case 'top-banner':
            return (React.createElement(Banner, { image: image === null || image === void 0 ? void 0 : image.original, mobileImage: image === null || image === void 0 ? void 0 : image.mobile, link: links[0], useContainer: true, useLazyLoading: false }));
        case 'content-banner':
            return (React.createElement(ContentBanner, { image: image === null || image === void 0 ? void 0 : image.original, mobileImage: image === null || image === void 0 ? void 0 : image.mobile, links: links, title: title, text: description, textColor: meta.textColor }));
        case 'rich-banner':
            var products = (_b = content === null || content === void 0 ? void 0 : content.products) !== null && _b !== void 0 ? _b : [];
            return (React.createElement(RichBanner, __assign({}, meta, { image: image === null || image === void 0 ? void 0 : image.original, mobileImage: image === null || image === void 0 ? void 0 : image.mobile, richText: richText === null || richText === void 0 ? void 0 : richText.value, link: links.find(function (l) { return l.style === 'image'; }) }), products.length > 0 && (React.createElement(ProductBlocksContainer, { skus: products.length > 6 ? products.slice(0, 6) : products, limit: 2, staticsUrl: grandvision === null || grandvision === void 0 ? void 0 : grandvision.staticsUrl, formatProductUrl: formatProductUrl, reimbursableLogos: {
                    default: siteLogos.reimbursable,
                    alternative: siteLogos.reimbursableAlternative,
                } }))));
        default:
            return (React.createElement(Heading$1, { variant: "subheading1" }, "Banner with template: " + template + " is not defined in CmsBanner component."));
    }
};
var CmsBanner$1 = compose(withBreakpointVisibility, withBloomreachData, withEditableContent, withAnchor)(CmsBanner);

var CmsBannerCollectionItem = withEditableContent(function (_a) {
    var content = _a.content, template = _a.template;
    var title = content.title, description = content.description, richText = content.content;
    var image = parseBloomreachImage(content.image);
    var links = useBloomreachLinks(content.links);
    switch (template) {
        case 'certificates':
            return (React.createElement(CertificatesItem, { image: image === null || image === void 0 ? void 0 : image.original, link: links[0], title: title, text: description }));
        case 'main-categories':
            return React.createElement(CategoryLinksItem, { image: image === null || image === void 0 ? void 0 : image.original, link: links[0], title: title });
        case 'usp':
            return (React.createElement(HighlightedContentItem, { image: image === null || image === void 0 ? void 0 : image.original, link: links[0], title: title, text: description }));
        case 'promotion-banner':
        case 'split-header-promotion':
            return (React.createElement(PromotionBannersItem, { image: image === null || image === void 0 ? void 0 : image.original, mobileImage: image === null || image === void 0 ? void 0 : image.mobile, link: links[0], title: title, text: description, fullWidth: template === 'split-header-promotion' }));
        case 'rich-banner':
            return (React.createElement(RichBanner, { image: image === null || image === void 0 ? void 0 : image.original, mobileImage: image === null || image === void 0 ? void 0 : image.mobile, richText: richText === null || richText === void 0 ? void 0 : richText.value, link: links.find(function (l) { return l.style === 'image'; }), backgroundColor: "white", textColor: "black", bannerWidth: "full", layout: "collection" }));
        default:
            return null;
    }
});
var CmsBannerCollection = function (_a) {
    var content = _a.content, template = _a.template, meta = _a.meta;
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var items = React.useMemo(function () {
        return content.items.map(function (item, i) { return (React.createElement(CmsBannerCollectionItem, { key: item.id + "-" + i, content: item, template: template })); });
    }, [content.items, template]);
    switch (template) {
        case 'certificates':
            return React.createElement(Certificates, null, items);
        case 'main-categories':
            return React.createElement(CategoryLinks, null, items);
        case 'usp':
            return React.createElement(HighlightedContent, null, items);
        case 'promotion-banner':
        case 'split-header-promotion':
            return (React.createElement(PromotionBanners, { fullWidth: template === 'split-header-promotion' }, items));
        case 'rich-banner':
            return (React.createElement(Container, null, isSmallScreen && meta.mobilePresentation === 'horizontal' ? (React.createElement(SliderCarousel, null, items)) : (React.createElement(FlexLayout, { justify: "space-between", wrap: "wrap" }, items))));
        default:
            return (React.createElement(Heading$1, { variant: "subheading1" }, "Banner collection with template: " + template + " is not defined in CmsBannerCollection component."));
    }
};
var CmsBannerCollection$1 = compose(withBloomreachPageable, withBreakpointVisibility, withAnchor)(CmsBannerCollection);

var CmsBlogCollectionItem = withEditableContent(function (_a) {
    var content = _a.content;
    var title = content.title, summary = content.summary, url = content.url;
    var coverImage = parseBloomreachImage(content.coverImage);
    var _b = __read(useBloomreachLinks([{ url: url !== null && url !== void 0 ? url : '#' }]), 1), link = _b[0];
    if (!coverImage) {
        return null;
    }
    return (React.createElement(HighlightedContentItem, { image: coverImage.original, title: title, text: summary, link: link }));
});
var CmsBlogCollection = function (_a) {
    var content = _a.content;
    return (React.createElement(HighlightedContent, null, content.items.map(function (item) { return (React.createElement(CmsBlogCollectionItem, { key: item.id, content: item })); })));
};
var BlogCollection = compose(withBreakpointVisibility, withHidableContent, withBloomreachPageable, withAnchor)(CmsBlogCollection);

var CmsBlogOverviewItem = function (_a) {
    var content = _a.content;
    var _b = useIntl(), locale = _b.locale, getLabel = _b.getLabel;
    var title = content.title, coverImage = content.coverImage, readingTime = content.readingTime, publishDate = content.publishDate, summary = content.summary, url = content.url;
    var _c = __read(useBloomreachLinks([{ url: url !== null && url !== void 0 ? url : '#' }]), 1), link = _c[0];
    var image = parseBloomreachImage(coverImage);
    return (React.createElement(BlogCard, { url: link.url, title: title, summary: summary, readingTime: readingTime, publishDate: publishDate, image: image === null || image === void 0 ? void 0 : image.original, mobileImage: image === null || image === void 0 ? void 0 : image.mobile, locale: locale, minutesLabel: getLabel('blog.minutesToRead') }));
};
var CmsBlogHero = function (_a) {
    var content = _a.content;
    var getLabel = useIntl().getLabel;
    var coverImage = content.coverImage, title = content.title, url = content.url, summary = content.summary;
    var _b = __read(useBloomreachLinks([{ url: url !== null && url !== void 0 ? url : '#' }]), 1), link = _b[0];
    var image = parseBloomreachImage(coverImage);
    if (!content || !image) {
        return null;
    }
    return (React.createElement(BlogHero, { title: title, link: link.url, summary: summary, image: image.original, mobileImage: image.mobile, readMoreLabel: getLabel('blog.readArticle') }));
};
var CmsBlogOverview = function (_a) {
    var component = _a.component, page = _a.page;
    var getLabel = useIntl().getLabel;
    var _b = component.getParameters().title, title = _b === void 0 ? 'Blog' : _b;
    var _c = useBloomreachArticles({
        component: component,
        page: page,
    }), loading = _c.loading, error = _c.error, result = _c.result, loadNextPage = _c.loadNextPage;
    if (error) {
        console.error('CmsBlogOverview: Failed to fetch more articles from Bloomreach.', error);
    }
    var highlighted = result.highlighted, paged = result.paged;
    var currentPage = paged.currentPage, nextPage = paged.nextPage, endPage = paged.endPage;
    var hasMoreItems = nextPage !== null && nextPage !== currentPage && nextPage <= endPage;
    if (!paged.items) {
        console.error('CmsBlogOverview: No blog items found to render.');
        return null;
    }
    return (React.createElement(React.Fragment, null,
        highlighted && React.createElement(CmsBlogHero, { content: highlighted }),
        React.createElement(BlogList, { title: title, noArticlesLabel: getLabel('blog.noArticles') }, paged.items.map(function (item) { return item && React.createElement(CmsBlogOverviewItem, { key: item.id, content: item }); })),
        hasMoreItems && (React.createElement("div", { className: "blog-list__show-more" },
            React.createElement(Button, { className: "blog-list__button", variant: "outline", color: "primary", isLoading: loading, onClick: loadNextPage, caption: getLabel('blog.articles.showMore') })))));
};
var BlogOverview = compose(withBreakpointVisibility, withAnchor)(CmsBlogOverview);

var CmsExclusiveBrandsItem = withEditableContent(function (_a) {
    var content = _a.content;
    var _b = __read(useBloomreachLinks([{ url: content.url }]), 1), link = _b[0];
    if (!content.brandLogo) {
        return null;
    }
    return (React__default.createElement(ExclusiveBrandsItem, { url: link.url, title: content.title, logoSrc: content.brandLogo.url }));
});
var CmsBrandCollection = function (_a) {
    var content = _a.content, template = _a.template;
    switch (template) {
        case 'exclusive-brands':
            return (React__default.createElement(ExclusiveBrands, null, content.items.map(function (brand) { return (React__default.createElement(CmsExclusiveBrandsItem, { key: brand.id, content: brand })); })));
        default:
            return (React__default.createElement(Heading$1, { variant: "subheading1" },
                "Banner of type ",
                template,
                " not defined in BrandCollection"));
    }
};
var BrandCollection = compose(withBreakpointVisibility, withHidableContent, withBloomreachPageable, withAnchor)(CmsBrandCollection);

var CmsBrandListItem = withEditableContent(function (_a) {
    var _b;
    var content = _a.content;
    var _c = __read(useBloomreachLinks([{ url: (_b = content.url) !== null && _b !== void 0 ? _b : '#' }]), 1), link = _c[0];
    return React__default.createElement(BrandListItem, { url: link.url }, content.title);
});
var CmsBrandList = function (_a) {
    var content = _a.content, meta = _a.meta, template = _a.template;
    var locale = useIntl().locale;
    switch (template) {
        case 'brand-list':
            var groups = groupBrands(content.items, 4, locale);
            return (React__default.createElement(BrandList$1, { title: String(meta.title) }, groups.map(function (_a, i) {
                var title = _a.title, items = _a.items;
                return (React__default.createElement(BrandListGroup, { title: title, key: i }, items.map(function (brand) { return (React__default.createElement(CmsBrandListItem, { content: brand, key: brand.id })); })));
            })));
        default:
            return (React__default.createElement(Heading$1, { variant: "subheading1" },
                "Banner of type ",
                template,
                " not defined in BrandList"));
    }
};
var BrandList = compose(withBreakpointVisibility, withHidableContent, withBloomreachPageable, withAnchor)(CmsBrandList);

var CmsCarouselItem = withEditableContent(function (_a) {
    var content = _a.content;
    var _b = __read(useBloomreachLinks(content.links), 1), link = _b[0];
    var image = parseBloomreachImage(content.image);
    if (!image) {
        return null;
    }
    return React.createElement(Banner, { image: image.original, mobileImage: image.mobile, link: link });
});
var CmsCarousel = function (_a) {
    var content = _a.content;
    var preview = useBloomreach().preview;
    return (React.createElement(Carousel, { autoLoop: !preview }, content.items.map(function (item) { return (React.createElement(CmsCarouselItem, { key: item.id, content: item })); })));
};
var CmsCarousel$1 = compose(withBreakpointVisibility, withBloomreachPageable, withAnchor)(CmsCarousel);

/**
 * This component wraps the component from the SDK that renders
 * any container-component from bloomreach based on the passed path.
 *
 * Any components inside this container will be rendered based on the
 * ComponentDefinitions we pass to SDK's page component.
 *
 * This component can be used to place certain containers in a page layout.
 * @example usage
 *   <Page>
 *     <CmsComponentSlot path="main/top-container" />
 *     <Cart />
 *     <SupportFooter />
 *     <CmsComponentSlot path="main/bottom-container" />
 *   </Page>
 */
var CmsComponentSlot = function (_a) {
    var _b = _a.path, path = _b === void 0 ? 'main' : _b, children = _a.children;
    return React.createElement(BrComponent, { path: path, children: children });
};

var CustomPackage = function (_a) {
    var meta = _a.meta;
    var customComponentMap = useBloomreach().customComponentMap;
    var element = customComponentMap && customComponentMap[meta.packageId];
    if (!element) {
        return React.createElement("div", null, "No component found for Custom Package ID: \"" + meta.packageId + "\"");
    }
    return React.createElement(element.type, __assign({}, element.props));
};
var CmsCustomPackage = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withAnchor)(CustomPackage);

var CmsIframe = function (_a) {
    var component = _a.component;
    var content = component.getModels().iframe;
    if (!content) {
        return null;
    }
    var source = content.source, scrolling = content.scrolling, height = content.height, position = content.position;
    return React.createElement(IFrame, { source: source, scrolling: scrolling, height: height, position: position });
};
var CmsIframe$1 = compose(withBreakpointVisibility, withHidableContent, withAnchor)(CmsIframe);

var CmsLinkList = function (_a) {
    var content = _a.content;
    var links = useBloomreachLinks(content.iconLinkCompoundList.map(function (_a) {
        var link = _a.link;
        return (__assign(__assign({}, link), { url: link.url || '#' }));
    }));
    return (React__default.createElement(Container, null,
        React__default.createElement(ContentTabs, { links: links })));
};
var CmsLinkList$1 = compose(withBreakpointVisibility, withBloomreachData, withEditableContent, withAnchor)(CmsLinkList);

var CmsRecommendedProducts = function (_a) {
    var meta = _a.meta;
    var grandvision = React__default.useContext(RuntimeContext).grandvision;
    var getLabel = useIntl().getLabel;
    var _b = __read(useBloomreachProductRoutes(), 2); _b[0]; var formatProductUrl = _b[1].formatProductUrl;
    return (React__default.createElement(FeaturedProducts, { formatProductUrl: formatProductUrl, skus: meta.recommendedProducts || [], staticsUrl: (grandvision === null || grandvision === void 0 ? void 0 : grandvision.staticsUrl) || '', title: getLabel('blog.content.recommendedProducts.title') }));
};
var CmsRecommendedProducts$1 = compose(withBreakpointVisibility, withEditableContent, withBloomreachData, withAnchor)(CmsRecommendedProducts);

/**
 * This variant of the Rich Text component is used on content pages
 */
var CmsRichTextDocument = function (_a) {
    var component = _a.component;
    var html = component.getModels().html;
    var _b = component.getParameters(), backgroundColor = _b.backgroundColor, textColor = _b.textColor;
    var richText = useBloomreachRichText(html);
    return React.createElement(RichTextArea, { content: richText, backgroundColor: backgroundColor, textColor: textColor });
};
var CmsRichTextDocument$1 = compose(withBreakpointVisibility, withAnchor)(CmsRichTextDocument);

var CmsVideo = function (_a) {
    var component = _a.component;
    var coverImage = component.getModels().coverImage;
    var videoUrl = component.getParameters().videoUrl;
    if (!videoUrl) {
        return null;
    }
    return React.createElement(Video, { videoUrl: videoUrl, coverImage: coverImage });
};
var CmsVideo$1 = compose(withBreakpointVisibility, withAnchor)(CmsVideo);

var CmsWidget = function (_a) {
    var content = _a.content, template = _a.template, meta = _a.meta;
    var _b = useFeatureToggles(), isGpsStoresEnabled = _b.isGpsStoresEnabled, isStoresPlacePredictionsEnabled = _b.isStoresPlacePredictionsEnabled;
    var title = content.title, links = content.links, inputField = content.inputField, image = content.image, text = content.content;
    var _c = __read(useBloomreachLinks(links), 1), link = _c[0];
    var input = parseBloomreachInputField(inputField);
    if (!input || !link) {
        return null;
    }
    switch (template) {
        case 'book-eye-check': // Old template name, can still occur sometimes in BR
        case 'book-appointment':
            return (React.createElement(BookAppointment, { title: title, link: link, inputField: input, isLocationEnabled: isGpsStoresEnabled, isPlacePredictionsEnabled: isStoresPlacePredictionsEnabled }));
        case 'book-appointment-extended':
            return (React.createElement(BookAppointment, { title: title, link: link, inputField: input, isLocationEnabled: isGpsStoresEnabled, isPlacePredictionsEnabled: isStoresPlacePredictionsEnabled, text: text === null || text === void 0 ? void 0 : text.value, imageUrl: image === null || image === void 0 ? void 0 : image.url, backgroundColor: meta === null || meta === void 0 ? void 0 : meta.backgroundColor, textColor: meta === null || meta === void 0 ? void 0 : meta.textColor }));
        default:
            return React.createElement(Heading$1, { variant: "subheading1" },
                "Widget of type: ",
                template,
                " is not defined.");
    }
};
var CmsWidget$1 = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsWidget);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var blockMap = {
    accordion: CmsAccordion$1,
    articleCollection: CmsArticleCollection$1,
    banner: CmsBanner$1,
    bannerCollection: CmsBannerCollection$1,
    carousel: CmsCarousel$1,
    customPackageComponent: CmsCustomPackage,
    iFrame: CmsIframe$1,
    linkList: CmsLinkList$1,
    recommendedProducts: CmsRecommendedProducts$1,
    video: CmsVideo$1,
    widget: CmsWidget$1,
    richText: CmsRichTextDocument$1,
};
var ContentBlock = function (_a) {
    var contentBlock = _a.contentBlock;
    var page = useBrPageContext();
    var component = mapBlockToComponent(contentBlock);
    var BlockComponent = getComponentForBlockType(contentBlock.type);
    var headingLevel = contentBlock.type === 'accordion' ? 'h4' : undefined;
    return BlockComponent && component ? (React.createElement(BlockComponent, { component: component, page: page, headingLevel: headingLevel })) : null;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getComponentForBlockType(type) {
    var Component = blockMap[type];
    if (!Component) {
        console.log("Missing Component for content block type: " + type);
        return;
    }
    return Component;
}
/**
 * The "ContentBlocks" implementation in the CMS used on content pages
 * is a custom modification of Bloomreach. Hence we need to map the content
 * object we receive to something for our CMS containers to a representation of
 * the "component" object they receive from the BR SDK by default.
 */
function mapBlockToComponent(_a) {
    var anchorId = _a.anchorId, coverImage = _a.coverImage, document = _a.document, expandedByDefault = _a.expandedByDefault, packageId = _a.packageId, recommendedProducts = _a.recommendedProducts, html = _a.html, template = _a.template, videoUrl = _a.videoUrl, visibility = _a.visibility, source = _a.source, height = _a.height, scrolling = _a.scrolling, imageWidth = _a.imageWidth, imageAlignment = _a.imageAlignment, bannerWidth = _a.bannerWidth, textColor = _a.textColor, backgroundColor = _a.backgroundColor, mobilePresentation = _a.mobilePresentation;
    var parsedDocument = Array.isArray(document) ? { pageable: { items: document } } : { document: document };
    function getModels() {
        return __assign(__assign({}, parsedDocument), { coverImage: coverImage, html: html, visibility: visibility, iframe: {
                source: source,
                height: height,
                scrolling: scrolling,
            } });
    }
    function getParameters() {
        return {
            anchorId: anchorId,
            packageId: packageId,
            template: template,
            videoUrl: videoUrl,
            expandedByDefault: expandedByDefault,
            recommendedProducts: recommendedProducts,
            imageWidth: imageWidth,
            imageAlignment: imageAlignment,
            bannerWidth: bannerWidth,
            textColor: textColor,
            backgroundColor: backgroundColor,
            mobilePresentation: mobilePresentation,
        };
    }
    return { getModels: getModels, getParameters: getParameters };
}

var CmsContentBlocks = function (_a) {
    var contentBlocks = _a.contentBlocks;
    return (React.createElement(React.Fragment, null, contentBlocks.map(function (contentBlock, i) { return (React.createElement(ContentBlock, { key: contentBlock.id + "-" + i, contentBlock: contentBlock })); })));
};

var CmsContentBreadcrumbs = function (_a) {
    var url = _a.url;
    var breadcrumbs = useBreadcrumbs(url);
    // Don't render if we have less than 2 breadcrumb items
    if (!breadcrumbs || breadcrumbs.length < 2) {
        return null;
    }
    return (React.createElement(Container, null,
        React.createElement(Breadcrumbs, { pages: breadcrumbs })));
};
function useBreadcrumbs(url) {
    if (url === void 0) { url = ''; }
    var _a = useIntl(), getLabel = _a.getLabel, hasLabel = _a.hasLabel, defaultLocale = _a.locale;
    var disableUrlRewriter = useBloomreach().disableUrlRewriter;
    var routes = useBloomreachPageRoutes().routes;
    var isMultilingualEnabled = useFeatureToggles().isMultilingualEnabled;
    var page = useBrPageContext();
    // Get locale from url because locale from cookies(intl) is not always up to date in preview mode
    var locale = LocaleUtils.getLocaleFromUrl(url) || defaultLocale;
    var localeStr = locale.replace('-', '_');
    var _b = __read(url === null || url === void 0 ? void 0 : url.split('?'), 2), _c = _b[0], path = _c === void 0 ? '' : _c, _d = _b[1], queryString = _d === void 0 ? '' : _d;
    var segments = path.split('/');
    // If we get an "internal" bloomreach url, we need to slice of the first three items (/site/_cmsinternal/[channel])
    // so they won't show up in the visual breadcrumbs
    if ((page === null || page === void 0 ? void 0 : page.isPreview()) && path.startsWith('/site/_cmsinternal')) {
        segments = __spreadArray([], __read(segments)).filter(function (s) { return s !== '' && s !== localeStr; })
            .slice(3, segments.length - 1);
    }
    else {
        segments = segments.filter(function (s) { return s !== '' && s !== localeStr; });
    }
    return __spreadArray([
        {
            name: getLabel("breadcrumb.breadcrumb.home"),
            url: disableUrlRewriter && (page === null || page === void 0 ? void 0 : page.isPreview()) ? page === null || page === void 0 ? void 0 : page.getUrl(routes.root) : routes.root,
        }
    ], __read(segments.map(function (currentSegment, index) {
        return createUrlBreadcrumb({
            currentSegment: currentSegment,
            segments: segments,
            queryString: queryString,
            index: index,
            getLabel: getLabel,
            hasLabel: hasLabel,
            page: page,
            disableUrlRewriter: disableUrlRewriter,
            locale: isMultilingualEnabled ? localeStr : undefined,
        });
    })));
}
function createUrlBreadcrumb(_a) {
    var segments = _a.segments, currentSegment = _a.currentSegment, queryString = _a.queryString, index = _a.index, getLabel = _a.getLabel, hasLabel = _a.hasLabel, page = _a.page, locale = _a.locale, disableUrlRewriter = _a.disableUrlRewriter;
    var previous = segments.slice(0, index).join('/');
    var labelKey = "breadcrumb.breadcrumb." + currentSegment;
    var name = hasLabel(labelKey)
        ? getLabel(labelKey)
        : StringUtils.upFirst(currentSegment.replace(/-/g, ' '));
    var url = Boolean(previous) ? "/" + previous + "/" + currentSegment : "/" + currentSegment;
    url += Boolean(queryString) ? "?" + queryString : '';
    if (locale) {
        url = "/" + locale + url;
    }
    return { url: disableUrlRewriter && (page === null || page === void 0 ? void 0 : page.isPreview()) ? page === null || page === void 0 ? void 0 : page.getUrl(url) : url, name: name };
}

var CmsCookieNotification = function () {
    var page = useBrPageContext();
    var component = useBrComponentContext();
    var documentRef = ((component === null || component === void 0 ? void 0 : component.getModels()) || {}).document;
    var document = page === null || page === void 0 ? void 0 : page.getContent(documentRef);
    var content = document === null || document === void 0 ? void 0 : document.getData();
    if (!content) {
        console.warn("No valid content supplied for cookie consent with ref: " + JSON.stringify(documentRef));
        return null;
    }
    return (React.createElement(React.Fragment, null,
        document && React.createElement(BrManageContentButton, { content: document }),
        React.createElement(CookieNotification, { content: content })));
};

var CmsDocument = function (_a) {
    var _b;
    var content = _a.content;
    var richText = useBloomreachRichText((_b = content.content) === null || _b === void 0 ? void 0 : _b.value);
    if (!richText) {
        return null;
    }
    return React.createElement(RichTextArea, { content: richText });
};
var Document = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsDocument);

var CmsEmpty = function (_a) {
    var component = _a.component, page = _a.page;
    var preview = page.isPreview();
    // This component should only render in CMS preview mode
    if (!preview) {
        return null;
    }
    return React.createElement("div", null, component === null || component === void 0 ? void 0 : component.getName());
};

var CmsFaqItem = withEditableContent(function (_a) {
    var content = _a.content;
    var name = content.name, question = content.question, answer = content.answer;
    return React.createElement(FaqItem, { id: name, question: question, answer: answer.value });
});
var CmsFaq = function (_a) {
    var _b;
    var page = _a.page, content = _a.content;
    var name = content.name, title = content.title, faqItems = content.faqItems;
    var items = (_b = faqItems === null || faqItems === void 0 ? void 0 : faqItems.map(function (item) {
        var document = page === null || page === void 0 ? void 0 : page.getContent(item);
        var content = parseBloomreachContent(document === null || document === void 0 ? void 0 : document.getData());
        return __assign(__assign({}, content), { document: document });
    })) !== null && _b !== void 0 ? _b : [];
    var ids = items.map(function (item) { var _a; return (_a = item === null || item === void 0 ? void 0 : item.name) !== null && _a !== void 0 ? _a : ''; });
    return (React.createElement(Faq$1, { name: name, title: title, ids: ids }, items.map(function (item, i) { return item && React.createElement(CmsFaqItem, { key: i + "-" + item.id, content: item }); })));
};
var Faq = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withAnchor)(CmsFaq);

var CmsFooter = function (_a) {
    var _b, _c;
    var _d = _a.useAlternativeLogoInFooter, useAlternativeLogoInFooter = _d === void 0 ? true : _d;
    var site = React.useContext(RuntimeContext).site;
    var _e = useBloomreach(), siteLogos = _e.siteLogos, disableUrlRewriter = _e.disableUrlRewriter;
    var page = useBrPageContext();
    var component = useBrComponentContext();
    var preview = page === null || page === void 0 ? void 0 : page.isPreview();
    var siteName = (_b = site === null || site === void 0 ? void 0 : site.name) !== null && _b !== void 0 ? _b : 'Unknown';
    var logo = {
        url: useAlternativeLogoInFooter ? siteLogos.alternative : siteLogos.main,
        altText: siteName,
    };
    if (!page || !component) {
        return null;
    }
    // Footer content
    var documentRef = component.getModels().document;
    var document = page.getContent(documentRef);
    var content = document === null || document === void 0 ? void 0 : document.getData();
    // Footer bottom menu
    var menuDocument = ((_c = component.getComponent('menu')) === null || _c === void 0 ? void 0 : _c.getModels()) || {};
    var menuItems = createMenu(menuDocument, page, disableUrlRewriter);
    return (React.createElement(React.Fragment, null,
        preview && document && (React.createElement("div", { style: { position: 'relative' } },
            React.createElement(BrManageContentButton, { content: document }))),
        content && (React.createElement(Footer, __assign({}, content, { logo: logo, siteName: siteName }), (menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) > 0 && (React.createElement(React.Fragment, null,
            preview && menuDocument.menu && (React.createElement("div", { style: { position: 'relative' } },
                React.createElement(BrManageMenuButton, { menu: menuDocument.menu }))),
            React.createElement(FooterLinks, { items: menuItems })))))));
};

var CmsHeader$1 = function (_a) {
    var headerLogo = _a.headerLogo, headerLogoMobile = _a.headerLogoMobile, headerLogoLink = _a.headerLogoLink, headerMenuItems = _a.headerMenuItems, navMenuItems = _a.navMenuItems, appointmentMenuItems = _a.appointmentMenuItems, headerMenuModel = _a.headerMenuModel, navMenuModel = _a.navMenuModel, appointmentMenuModel = _a.appointmentMenuModel, pageRoutes = _a.pageRoutes, availableLocales = _a.availableLocales, countrySwitcherOptions = _a.countrySwitcherOptions, myAccountButton = _a.myAccountButton, preview = _a.preview, isSolaris = _a.isSolaris, renderCartButton = _a.renderCartButton, isMultilingualEnabled = _a.isMultilingualEnabled, onSubmitSearch = _a.onSubmitSearch, formatProductUrl = _a.formatProductUrl, staticsUrl = _a.staticsUrl, algoliaHeaderConfig = _a.algoliaHeaderConfig, _b = _a.renderSiteNav, renderSiteNav = _b === void 0 ? true : _b, siteName = _a.siteName;
    return (React.createElement(React.Fragment, null,
        preview && headerMenuModel && (React.createElement("div", { style: { position: 'relative' } },
            React.createElement(BrManageMenuButton, { menu: headerMenuModel }))),
        React.createElement(Header, { logo: headerLogo, logoMobile: headerLogoMobile, logoLink: headerLogoLink, pageRoutes: pageRoutes, menuItems: headerMenuItems, myAccountButton: myAccountButton, renderCartButton: renderCartButton, isMultilingualEnabled: isMultilingualEnabled, availableLocales: availableLocales, staticsUrl: staticsUrl, algoliaHeaderConfig: algoliaHeaderConfig, onSubmit: onSubmitSearch, preview: preview, countrySwitcherOptions: countrySwitcherOptions, renderSiteNav: renderSiteNav, siteName: siteName, formatProductUrl: formatProductUrl }, renderSiteNav && (React.createElement(React.Fragment, null,
            preview && navMenuModel && (React.createElement("div", { style: { position: 'relative' } },
                React.createElement(BrManageMenuButton, { menu: navMenuModel }))),
            React.createElement(SiteNav, { menuItems: navMenuItems, appointmentItems: appointmentMenuItems, isSolaris: isSolaris, routes: { cart: pageRoutes.cart, stores: pageRoutes.stores }, countrySwitcherOptions: countrySwitcherOptions, renderCartButton: renderCartButton }),
            preview && appointmentMenuModel && (React.createElement("div", { style: { position: 'relative' } },
                React.createElement(BrManageMenuButton, { menu: appointmentMenuModel }))))))));
};

function isMoreSpecific(nextLink, prevLink) {
    if (nextLink === void 0) { nextLink = ''; }
    if (prevLink === void 0) { prevLink = ''; }
    var isEqual = (nextLink.match(/\//g) || []).length === (prevLink.match(/\//g) || []).length;
    if (isEqual) {
        return nextLink.length > prevLink.length;
    }
    else {
        return (nextLink.match(/\//g) || []).length > (prevLink.match(/\//g) || []).length;
    }
}
function checkIfActive(currentPath, itemPath) {
    if (currentPath === void 0) { currentPath = ''; }
    if (itemPath === void 0) { itemPath = ''; }
    // root c.q. home
    if (currentPath === '/' && itemPath === '/') {
        return true;
    }
    else {
        return currentPath.startsWith(itemPath);
    }
}
function convertToBloomreachMenuItem(items) {
    var getHref = function (item) { return (item.link ? item.link.href : ''); };
    return items.map(function (item) {
        var _a;
        return (__assign(__assign({}, item), { name: item.label, depth: 1, expanded: false, selected: false, repositoryBased: false, _links: {
                site: {
                    href: getHref(item),
                    type: 'external',
                    active: (_a = item.link) === null || _a === void 0 ? void 0 : _a.active,
                },
            }, parameters: __assign({}, item.parameters), childMenuItems: (item.childMenuItems || []).map(function (childItem) { return (__assign(__assign({}, childItem), { name: childItem.label, depth: 1, expanded: false, selected: false, repositoryBased: false, parameters: __assign({}, childItem.parameters), childMenuItems: [], _links: {
                    site: {
                        href: getHref(childItem),
                        type: 'external',
                    },
                } })); }) }));
    });
}
var createMyAccountMobileMenuStructure = function (intl, formattedRoutes, logout, isLoggedIn, isAddressBookEnabled, isAABEnabled, isSubscriptionsV2Enabled) {
    var submenu = [
        {
            name: '',
            depth: 1,
            expanded: false,
            repositoryBased: false,
            selected: false,
            _links: {},
            parameters: {},
            childMenuItems: formattedRoutes
                ? convertToBloomreachMenuItem(Utils.getMyAccountMenuItems(logout, formattedRoutes, intl, isLoggedIn, isAddressBookEnabled, isAABEnabled, isSubscriptionsV2Enabled))
                : [],
        },
    ];
    return {
        name: intl.getLabel('account.menu.myAccount'),
        depth: 0,
        expanded: false,
        repositoryBased: false,
        selected: false,
        _links: {},
        parameters: {
            menuKey: 'my-account',
        },
        childMenuItems: submenu,
    };
};
var createLocaleSwitcherMenuStructure = function (availableLocales, intl) {
    var localeSwitcherMenuLabel = getLocaleSwitcherMenuLabel(intl.locale);
    var localeMenuItems = getLocaleSwitcherData(availableLocales, false);
    var activeLocale = availableLocales.find(function (item) { return item.locale.replace('_', '-') === intl.locale; });
    return {
        label: localeSwitcherMenuLabel,
        parameters: { menuKey: 'locale-switcher' },
        childMenuItems: [
            {
                label: activeLocale ? activeLocale.chooseLanguage : localeSwitcherMenuLabel,
                childMenuItems: localeMenuItems,
            },
        ],
    };
};
var getCountrySwitcherUrls = function (content) {
    if (!(content === null || content === void 0 ? void 0 : content.imageLinkList)) {
        return undefined;
    }
    return content.imageLinkList.map(function (item) {
        var _a, _b, _c, _d, _e, _f, _g;
        return ({
            image: (_b = (_a = item.image) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : '',
            label: (_d = (_c = item.link) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : '',
            url: (_f = (_e = item.link) === null || _e === void 0 ? void 0 : _e.url) !== null && _f !== void 0 ? _f : '',
            openInNewWindow: ((_g = item.link) === null || _g === void 0 ? void 0 : _g.openInNewWindow) || false,
        });
    });
};
var withMyAccountMenuItems = function (navMenuData, intl, formattedRoutes, logout, isLoggedIn, isAddressBookEnabled, isAABEnabled, isSubscriptionsV2Enabled) {
    var _a;
    var myAccountMenuItems = createMyAccountMobileMenuStructure(intl, formattedRoutes, logout, isLoggedIn, isAddressBookEnabled, isAABEnabled, isSubscriptionsV2Enabled);
    return __assign(__assign({}, navMenuData), { menu: __assign(__assign({}, navMenuData === null || navMenuData === void 0 ? void 0 : navMenuData.menu), { name: 'my-account-menu', selectSiteMenuItem: null, siteMenuItems: __spreadArray(__spreadArray([], __read((((_a = navMenuData === null || navMenuData === void 0 ? void 0 : navMenuData.menu) === null || _a === void 0 ? void 0 : _a.siteMenuItems) || []))), [myAccountMenuItems]) }) });
};
var CmsHeader = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var intl = useIntl();
    var page = useBrPageContext();
    var component = useBrComponentContext();
    var _h = useFeatureToggles(), isAddressBookEnabled = _h.isAddressBookEnabled, isMultilingualEnabled = _h.isMultilingualEnabled, isMyAccountEnabled = _h.isMyAccountEnabled, isSubscriptionsV2Enabled = _h.isSubscriptionsV2Enabled, isAABEnabled = _h.isAABEnabled;
    var _j = React.useContext(RuntimeContext), algolia = _j.algolia, grandvision = _j.grandvision, site = _j.site, bloomreach = _j.bloomreach;
    var _k = useBloomreach(), siteLogos = _k.siteLogos, preview = _k.preview, path = _k.path, disableUrlRewriter = _k.disableUrlRewriter;
    var _l = __read(useBloomreachProductRoutes(), 2); _l[0]; var formatProductUrl = _l[1].formatProductUrl;
    var pageRoutes = useBloomreachPageRoutes().routes;
    var siteName = (_a = site === null || site === void 0 ? void 0 : site.name) !== null && _a !== void 0 ? _a : 'Unknown';
    var logoLink = disableUrlRewriter && (page === null || page === void 0 ? void 0 : page.isPreview())
        ? page === null || page === void 0 ? void 0 : page.getUrl(pageRoutes.root || '/')
        : pageRoutes.root || '/';
    // My account actions
    var dispatch = useDispatch();
    var logout = React.useCallback(function () { return dispatch(Actions.LogoutActions.logOut()); }, [dispatch]);
    var recoverSession = React.useCallback(function () { return dispatch(Actions.LoginActions.recoverSession()); }, [dispatch]);
    // My account state
    var auth = useSelector(Selectors.getAuth);
    var formattedRoutes = useSelector(Selectors.getFormattedRoutes);
    /**
     * State
     */
    var _m = __read(React.useState(false), 2), mounted = _m[0], setMounted = _m[1];
    /**
     * Create all menu data with BrPageModel
     */
    var _o = (_c = (_b = page === null || page === void 0 ? void 0 : page.getComponent()) === null || _b === void 0 ? void 0 : _b.getModels()) !== null && _c !== void 0 ? _c : {}, _p = _o.routes, routes = _p === void 0 ? {} : _p, localeOptions = _o.localeOptions, countrySwitcher = _o.countrySwitcher;
    var headerMenu = (_d = component === null || component === void 0 ? void 0 : component.getComponent('top-menu')) === null || _d === void 0 ? void 0 : _d.getModels();
    var navMenu = (_e = component === null || component === void 0 ? void 0 : component.getComponent('main-menu')) === null || _e === void 0 ? void 0 : _e.getModels();
    var appointmentMenu = (_f = component === null || component === void 0 ? void 0 : component.getComponent('appointment-menu')) === null || _f === void 0 ? void 0 : _f.getModels();
    // Country switcher - this is not the language/locale switcher
    var countrySwitcherContent = countrySwitcher && (page === null || page === void 0 ? void 0 : page.getContent(countrySwitcher));
    var countrySwitcherOptions = getCountrySwitcherUrls(countrySwitcherContent === null || countrySwitcherContent === void 0 ? void 0 : countrySwitcherContent.getData());
    var headerMenuItems = createMenu(headerMenu, page, disableUrlRewriter);
    var appointmentMenuItems = createMenu(appointmentMenu, page, disableUrlRewriter);
    /**
     * Using refs so these static objects are not re-created on each render
     */
    var headerLogo = React.useRef({
        url: siteLogos.main,
        altText: siteName,
    });
    var headerLogoMobile = React.useRef({
        url: siteLogos.mobile,
        altText: siteName,
    });
    /**
     * My account menu setup
     */
    var authRef = React.useRef(auth);
    var isUserLoggedIn = State.getLoggedInState(auth) === 'logged-in';
    var myAccountButton = React.useMemo(function () {
        if (!isMyAccountEnabled || !formattedRoutes) {
            return null;
        }
        var menuItems = Utils.getMyAccountMenuItems(logout, formattedRoutes, intl, isUserLoggedIn, isAddressBookEnabled, isAABEnabled, isSubscriptionsV2Enabled);
        var items = convertToBloomreachMenuItem(menuItems);
        return React.createElement(MyAccountMenu, { menuItems: mapToMenu(items, page) });
    }, [
        isMyAccountEnabled,
        formattedRoutes,
        logout,
        intl,
        isUserLoggedIn,
        isAddressBookEnabled,
        isAABEnabled,
        isSubscriptionsV2Enabled,
        page,
    ]);
    React.useEffect(function () {
        // Runs on mount and updates
        if ((!mounted || State.isUninitialized(authRef.current)) && State.isInitialized(auth)) {
            recoverSession();
        }
        setMounted(true);
        authRef.current = auth;
        // Let analytics know if user is logged in
        setUserObject(isUserLoggedIn);
    }, [mounted, auth, recoverSession, isUserLoggedIn]);
    /**
     * Navigation menu items with my account menu
     */
    var navMenuItems = React.useMemo(function () {
        var data = isMyAccountEnabled
            ? withMyAccountMenuItems(navMenu, intl, formattedRoutes, logout, isUserLoggedIn, isAddressBookEnabled, isSubscriptionsV2Enabled, isAABEnabled)
            : navMenu;
        var menuItems = createMenu(data, page, disableUrlRewriter);
        var result = isMultilingualEnabled
            ? __spreadArray(__spreadArray([], __read(menuItems)), [createLocaleSwitcherMenuStructure(localeOptions || [], intl)]) : menuItems;
        var currentPath = path === null || path === void 0 ? void 0 : path.split('?')[0];
        // TODO: this should be changed when the upgrade to BR 14.5 is done
        var previewLinkPrefix = "/site/_cmsinternal/" + (bloomreach === null || bloomreach === void 0 ? void 0 : bloomreach.channel);
        // Check if a sitenav item's url corresponds with the current url path
        var activeItems = result.filter(function (menuItem) { var _a; return checkIfActive(currentPath, (((_a = menuItem.link) === null || _a === void 0 ? void 0 : _a.href) || '').replace(previewLinkPrefix, '')); });
        var active = activeItems
            .sort(function (a, b) { var _a, _b; return (isMoreSpecific((_a = a.link) === null || _a === void 0 ? void 0 : _a.href, (_b = b.link) === null || _b === void 0 ? void 0 : _b.href) ? -1 : 1); })
            .shift();
        if (active === null || active === void 0 ? void 0 : active.link) {
            active.link = __assign(__assign({}, active.link), { active: true });
        }
        return result;
    }, [
        isMyAccountEnabled,
        isSubscriptionsV2Enabled,
        navMenu,
        intl,
        formattedRoutes,
        logout,
        isUserLoggedIn,
        isAddressBookEnabled,
        isAABEnabled,
        page,
        disableUrlRewriter,
        isMultilingualEnabled,
        localeOptions,
        path,
        bloomreach === null || bloomreach === void 0 ? void 0 : bloomreach.channel,
    ]);
    /**
     * Search callback
     */
    var handleSearch = React.useCallback(function (query, type) {
        if (!algolia) {
            return;
        }
        var indexes = algolia.indexes, productIndex = algolia.productIndex;
        var storeIndex = indexes === null || indexes === void 0 ? void 0 : indexes.find(function (index) { return index.type === 'stores'; });
        switch (type) {
            case 'products':
                window.location.assign("" + productIndex.targetPath + encodeURIComponent(query));
                break;
            case 'stores':
                storeIndex &&
                    window.location.assign("" + storeIndex.targetPath + encodeURIComponent(query));
                break;
            default:
                console.warn("Trying to perform search action for unknown Algolia index type: " + type);
        }
    }, [algolia]);
    if ((!headerMenu || !headerMenuItems) && (!navMenu || !navMenuItems)) {
        console.error('No configuration or components found for Header in CMS model!');
        return null;
    }
    return (React.createElement(CmsHeader$1, __assign({}, props, { isSolaris: (_g = props.isSolaris) !== null && _g !== void 0 ? _g : false, headerMenuModel: headerMenu === null || headerMenu === void 0 ? void 0 : headerMenu.menu, headerMenuItems: headerMenuItems, headerLogoLink: logoLink, navMenuModel: navMenu === null || navMenu === void 0 ? void 0 : navMenu.menu, navMenuItems: navMenuItems, appointmentMenuModel: appointmentMenu === null || appointmentMenu === void 0 ? void 0 : appointmentMenu.menu, appointmentMenuItems: appointmentMenuItems, myAccountButton: myAccountButton, onSubmitSearch: handleSearch, preview: preview, availableLocales: localeOptions, countrySwitcherOptions: countrySwitcherOptions, headerLogo: headerLogo.current, headerLogoMobile: headerLogoMobile.current, pageRoutes: routes, isMultilingualEnabled: isMultilingualEnabled, formatProductUrl: formatProductUrl, staticsUrl: (grandvision === null || grandvision === void 0 ? void 0 : grandvision.staticsUrl) || '', algoliaHeaderConfig: algolia })));
};

function rewriteCanonical(canonicalUrl, selfUrl, pageNr) {
    // Strip scheme and host from url and save just the pathname parts
    var _a = __read(canonicalUrl.split('/')), path = _a.slice(3);
    var pageParameter = pageNr && pageNr !== 1 ? "?page=" + pageNr : '';
    return selfUrl + "/" + path.join('/') + pageParameter;
}
function createHreflangLink(hreflang, selfUrl) {
    var absoluteUrlPattern = /^https?:\/\/|^\/\//i;
    var url = absoluteUrlPattern.test(hreflang.url)
        ? hreflang.url
        : "" + (selfUrl || '') + hreflang.url;
    var locale = hreflang.locale.replace('_', '-').toLowerCase();
    return { url: url, locale: locale };
}
var CmsHeadTags = function (_a) {
    var title = _a.title, description = _a.description, ogUrl = _a.ogUrl, ogImage = _a.ogImage, hreflangs = _a.hreflangs, noIndex = _a.noIndex, noFollow = _a.noFollow, pageNr = _a.pageNr, children = _a.children;
    return (React.createElement(RuntimeContext.Consumer, null, function (_a) {
        var headComponent = _a.headComponent, selfUrl = _a.selfUrl, _b = _a.site, site = _b === void 0 ? {} : _b;
        var siteName = site.name || '';
        var props = {
            title: title ? title + " | " + siteName : siteName,
            description: description || site.description || '',
            ogImage: ogImage || site.ogImage || '',
            ogUrl: rewriteCanonical(ogUrl || site.url || '', selfUrl, pageNr),
            hreflangs: Array.isArray(hreflangs) && hreflangs.length > 1
                ? hreflangs.map(function (entry) { return createHreflangLink(entry, selfUrl); })
                : [],
            headComponent: headComponent,
            noIndex: noIndex,
            noFollow: noFollow,
            children: children,
        };
        return React.createElement(HeadTags, __assign({}, props));
    }));
};

var variantMap = {
    h1: 'large',
    h2: 'medium',
    h3: 'small',
    h4: 'smallest',
    h5: 'subheading1',
    h6: 'subheading2',
};
var CmsHeading = function (_a) {
    var _b = _a.meta, title = _b.title, type = _b.type, alignment = _b.alignment;
    return (React.createElement(Heading$1, { className: "heading heading--" + alignment, variant: variantMap[type], align: alignment }, title));
};
var Heading = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withAnchor)(CmsHeading);

var CmsIconList = function (_a) {
    var page = _a.page, content = _a.content, theme = _a.theme;
    var disableUrlRewriter = useBloomreach().disableUrlRewriter;
    var _b = content.iconLinkCompoundList, iconLinkCompoundList = _b === void 0 ? [] : _b, title = content.title;
    var items = React.useMemo(function () {
        return iconLinkCompoundList.map(function (_a) {
            var _b;
            var icon = _a.icon, link = _a.link;
            var url = disableUrlRewriter && page.isPreview() ? page.getUrl((_b = link.url) !== null && _b !== void 0 ? _b : '') : link.url;
            return {
                icon: icon,
                url: url,
                label: link.label,
            };
        });
    }, [disableUrlRewriter, iconLinkCompoundList, page]);
    return React.createElement(IconList$1, { items: items, title: title, theme: theme });
};
var IconList = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsIconList);

var CmsNotificationBar = function (_a) {
    var _b;
    var content = _a.content, _c = _a.theme, theme = _c === void 0 ? 'dark' : _c;
    var title = content.title, description = content.description, links = content.links;
    var _d = __read(useBloomreachLinks(links), 1), link = _d[0];
    if (!title && !description) {
        return null;
    }
    return (React.createElement(NotificationBar$1, { title: title, description: description, theme: theme, link: __assign(__assign({}, link), { label: (_b = link === null || link === void 0 ? void 0 : link.label) !== null && _b !== void 0 ? _b : '' }) }));
};
var NotificationBar = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsNotificationBar);

var CmsOlapic = function (_a) {
    var meta = _a.meta;
    var locale = useIntl().locale;
    var _b = React__default.useContext(RuntimeContext).olapic, apiKey = _b.apiKey, url = _b.url;
    return (React__default.createElement(Olapic$1, { apiKey: apiKey, instance: meta.instance, locale: locale.replace('_', '-'), olapic: meta.olapic, src: url, tags: meta.tags }));
};
var Olapic = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withAnchor)(CmsOlapic);

var CmsPolicyBar = function (_a) {
    var _b;
    var content = _a.content, _c = _a.theme, theme = _c === void 0 ? 'default' : _c;
    if (!((_b = content === null || content === void 0 ? void 0 : content.policyItems) === null || _b === void 0 ? void 0 : _b.length)) {
        return null;
    }
    return React.createElement(UspGroup, { items: content.policyItems, theme: theme });
};
var PolicyBar = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsPolicyBar);

function createProductBreadcrumb(categoryBreadcrumb, product, productType, sku, locale) {
    var activeVariant = Helpers.getActiveVariant(product, sku);
    var productName = product && getLocalizedValue(product.name, locale);
    if (productType &&
        (CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType))) {
        return productName && sku && categoryBreadcrumb ? { name: productName } : null;
    }
    if (productType && CommerceToolsApi.isSolutions(productType)) {
        var packageOption = activeVariant && getAttrValue(activeVariant, 'packageOption');
        return productName && packageOption && sku && categoryBreadcrumb
            ? { name: productName + " " + packageOption }
            : null;
    }
    return activeVariant.name && sku && categoryBreadcrumb ? { name: activeVariant.name } : null;
}

function getCategoryRoute(pageModel, productType) {
    var _a;
    if (productType === void 0) { productType = ''; }
    var _b = ((_a = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page.models) !== null && _a !== void 0 ? _a : {}).productRoutes, productRoutes = _b === void 0 ? {} : _b;
    var key = Object.keys(productRoutes).find(function (key) { return key === productType && productRoutes; });
    return key && productRoutes[key];
}

function createSubCategoryBreadcrumb(categoryRoute, product, productType, locale, page, disableUrlRewriter) {
    // Append a token when condition is met, otherwise return normal url
    var createUrl = function (url) {
        return disableUrlRewriter && (page === null || page === void 0 ? void 0 : page.isPreview()) ? page === null || page === void 0 ? void 0 : page.getUrl(url) : url;
    };
    // If the productType is of lenses we will use the replacementFrequency to create the url
    if (productType && CommerceToolsApi.isLenses(productType)) {
        var replacementFrequency = getLocalizedAttrValue(product.masterVariant, 'replacementFrequency', locale) || '';
        return replacementFrequency != ''
            ? {
                name: replacementFrequency,
                url: createUrl(categoryRoute + "/" + encodeURIComponent(sanitizeStringForUrl(replacementFrequency))),
            }
            : null;
    }
    // If the productType is solutions we will use the contactLensCareType to create the url
    if (productType && CommerceToolsApi.isSolutions(productType)) {
        var contactLensCareType = (product && getLocalizedAttrValue(product.masterVariant, 'contactLensCareType', locale)) || '';
        return contactLensCareType
            ? {
                name: contactLensCareType,
                url: categoryRoute + ("?contactLensCareType=" + contactLensCareType),
            }
            : null;
    }
    var brand = getAttrValue(product.masterVariant, 'brand');
    return isString(brand) && brand !== ''
        ? {
            name: String(brand),
            url: createUrl(categoryRoute + "/" + encodeURIComponent(sanitizeStringForUrl(brand))),
        }
        : null;
}

/** Returns the main-menu data from the page model */
function getMainMenuItems(pageModel) {
    var _a, _b;
    var menu = getComponentByPath('header/main-menu', pageModel);
    return (_b = (_a = menu === null || menu === void 0 ? void 0 : menu.models) === null || _a === void 0 ? void 0 : _a.menu.siteMenuItems) !== null && _b !== void 0 ? _b : [];
}
/** Returns the name that belongs to a given route from the main menu */
function getNameByProductRoute(categoryRoute, pageModel) {
    var menu = getMainMenuItems(pageModel);
    var route = findRouteByUrl(categoryRoute, menu);
    return route && route.name;
}
/**  Returns the route for a given url and an array of menu items */
function findRouteByUrl(categoryRoute, routes) {
    var e_1, _a;
    var _b, _c;
    try {
        for (var routes_1 = __values(routes), routes_1_1 = routes_1.next(); !routes_1_1.done; routes_1_1 = routes_1.next()) {
            var route = routes_1_1.value;
            if (((_b = route._links.site) === null || _b === void 0 ? void 0 : _b.href) && ((_c = route._links.site) === null || _c === void 0 ? void 0 : _c.href) === categoryRoute) {
                return route;
            }
            // Check the childMenuItems for the route
            if (route.childMenuItems.length) {
                var result = findRouteByUrl(categoryRoute, route.childMenuItems);
                if (result)
                    return result;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (routes_1_1 && !routes_1_1.done && (_a = routes_1.return)) _a.call(routes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function createCategoryBreadcrumb(pageModel, categoryRoute, page, disableUrlRewriter) {
    if (!pageModel || !categoryRoute) {
        return null;
    }
    var name = getNameByProductRoute(categoryRoute, pageModel);
    var url = disableUrlRewriter && (page === null || page === void 0 ? void 0 : page.isPreview()) ? page === null || page === void 0 ? void 0 : page.getUrl(categoryRoute) : categoryRoute;
    return name ? { name: name, url: url } : null;
}

var CmsProductBreadcrumbs = function (_a) {
    var _b;
    var product = _a.product, sku = _a.sku;
    var locale = useIntl().locale;
    var _c = useBloomreach(), pageModel = _c.pageModel, disableUrlRewriter = _c.disableUrlRewriter;
    var page = useBrPageContext();
    var productType = (_b = product.productType.obj) === null || _b === void 0 ? void 0 : _b.name;
    var categoryRoute = getCategoryRoute(pageModel, productType);
    if (!categoryRoute) {
        console.warn('Could not find a product category route to render PDP breadcrumbs');
        return null;
    }
    var categoryBreadcrumb = createCategoryBreadcrumb(pageModel, categoryRoute, page, disableUrlRewriter);
    var subCategoryBreadcrumb = createSubCategoryBreadcrumb(categoryRoute, product, productType, locale, page, disableUrlRewriter);
    var productBreadcrumb = createProductBreadcrumb(categoryBreadcrumb, product, productType, sku, locale);
    var breadcrumbs = [categoryBreadcrumb, subCategoryBreadcrumb, productBreadcrumb].filter(Boolean);
    return (React.createElement(Container, null,
        React.createElement(Breadcrumbs, { pages: breadcrumbs })));
};

function createProductTypeBreadcrumb(pageRoutes, path, transformUrl) {
    if (path === void 0) { path = ''; }
    var _a = findProductTypeUrl(pageRoutes, path), name = _a.name, url = _a.url;
    return {
        name: name || '',
        url: url && transformUrl ? transformUrl(url) : url,
    };
}
function findProductTypeUrl(pageRoutes, path) {
    // Inverse pageRoutes so we can access it by path instead of name
    var routesByPath = Object.entries(pageRoutes).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        acc[value] = key;
        return acc;
    }, {});
    // Retrieve combined path segments and check if it exists in the pageRoutes
    var routes = getRouteSegmentsByPath(path);
    var productTypePath = routes.find(function (route) { return route in routesByPath; });
    return productTypePath ? { url: productTypePath, name: routesByPath[productTypePath] } : {};
}
/**
 * Returns all possible combined path segments from a given path
 * For a path '/contact-lenses/solutions/branding` we would like to have all possible combined sections:
 *    `/contact-lenses/solutions/branding`
 *    `/contact-lenses/solutions`
 *    `/contact-lenses`
 */
function getRouteSegmentsByPath(path) {
    return path
        .split('/')
        .slice(1)
        .reduce(function (prev, curr, index) {
        // append the current path section to the previous section
        var newPathSection = prev[index].concat("/" + curr);
        prev.push(newPathSection);
        return prev;
    }, [''])
        .slice(1)
        .reverse();
}
var getProductTypeName = function (breadcrumb, pageModel, getLabel) {
    var _a;
    var productTypeName = pageModel && breadcrumb.url && getNameByProductRoute(breadcrumb.url, pageModel);
    return productTypeName
        ? productTypeName
        : getLabel("products." + ((_a = breadcrumb.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()), {
            defaultValue: breadcrumb.name,
        });
};

var CmsProductCatalogBreadcrumbs = function (_a) {
    var title = _a.title;
    var _b = __read(useBloomreachProductRoutes(), 3), pageRoutes = _b[2];
    var routes = useBloomreachPageRoutes().routes;
    var _c = useBloomreach(), pageModel = _c.pageModel, path = _c.path, disableUrlRewriter = _c.disableUrlRewriter;
    var page = useBrPageContext();
    var getLabel = useIntl().getLabel;
    var createUrl = function (url) {
        return url && disableUrlRewriter && (page === null || page === void 0 ? void 0 : page.isPreview()) ? page.getUrl(url) : url;
    };
    // Remove parameters from the path
    var sanitizedPath = path === null || path === void 0 ? void 0 : path.split('?')[0];
    // Create the root route
    var rootBreadcrumb = {
        name: getLabel('account.menu.home', { defaultValue: 'Home' }),
        url: createUrl(routes.root),
    };
    var breadcrumbs = [rootBreadcrumb];
    // Retrieve the product type breadcrumb
    var productTypeBreadcrumb = createProductTypeBreadcrumb(pageRoutes, sanitizedPath, createUrl);
    if (productTypeBreadcrumb.name) {
        // Get the localized productType name
        productTypeBreadcrumb.name = getProductTypeName(productTypeBreadcrumb, pageModel, getLabel);
        breadcrumbs.push(productTypeBreadcrumb);
    }
    // If the path is not equal to the path of the productType breadcrumb,
    // we are not on a standard productType page and will use the title as the last breadcrumb
    if (productTypeBreadcrumb.url !== sanitizedPath) {
        breadcrumbs.push({ name: title });
    }
    return React__default.createElement(ProductCatalogBreadcrumbs, { breadcrumbs: breadcrumbs });
};

function getPromotion(_a) {
    var page = _a.page, ref = _a.ref;
    var document = ref && page.getContent(ref);
    var content = document === null || document === void 0 ? void 0 : document.getData();
    if (!document) {
        return undefined;
    }
    return __assign(__assign({}, content), { links: content === null || content === void 0 ? void 0 : content.links[0], manageContentButton: React__default.createElement(BrManageContentButton, { content: document }) });
}
var CmsProductCatalog = function (_a) {
    var page = _a.page, content = _a.content;
    var getLabel = useIntl().getLabel;
    var isEnabled = useAlgoliaConfig().isEnabled;
    var grandvision = React__default.useContext(RuntimeContext).grandvision;
    var _b = __read(useBloomreachProductRoutes(), 2); _b[0]; var formatProductUrl = _b[1].formatProductUrl;
    var siteLogos = useBloomreach().siteLogos;
    var title = content.title, smallPromotion = content.smallPromotion, bigPromotion = content.bigPromotion;
    if (!isEnabled) {
        console.error("You're trying to render the <CmsProductCatalog />, but the `AlgoliaConfig` is not configured properly.");
        return null;
    }
    var promotionSmall = getPromotion({ page: page, ref: smallPromotion });
    var promotionBig = getPromotion({ page: page, ref: bigPromotion });
    return (React__default.createElement(AlgoliaSearch, null, function (stateResults) {
        var _a;
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(CmsProductCatalogBreadcrumbs, { title: title }),
            React__default.createElement(SearchPageHeader, { pageTitle: title, hitTitle: (stateResults === null || stateResults === void 0 ? void 0 : stateResults.searchResults.nbHits) + " " + getLabel('search.results.amount.title'), description: (_a = content.description) === null || _a === void 0 ? void 0 : _a.value }),
            React__default.createElement(ConnectedProductListing, { formatProductUrl: formatProductUrl, staticsUrl: (grandvision === null || grandvision === void 0 ? void 0 : grandvision.staticsUrl) || '', promotionSmall: promotionSmall, promotionBig: promotionBig, reimbursableLogos: {
                    default: siteLogos.reimbursable,
                    alternative: siteLogos.reimbursableAlternative,
                } }),
            React__default.createElement(ScrollUpButton, null)));
    }));
};
var ProductCatalog = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsProductCatalog);

var CmsPromotion = function (_a) {
    var content = _a.content;
    var _b = content.products, products = _b === void 0 ? [] : _b, _c = content.supertitle, supertitle = _c === void 0 ? '' : _c, _d = content.title, title = _d === void 0 ? '' : _d, _e = content.promotionLabel, promotionLabel = _e === void 0 ? '' : _e;
    var grandvision = React.useContext(RuntimeContext).grandvision;
    var _f = __read(useBloomreachProductRoutes(), 2); _f[0]; var formatProductUrl = _f[1].formatProductUrl;
    if (!products.length || (!title && !supertitle)) {
        console.error('Missing content for Promotion in CMS model, please supply products and a title or supertitle!');
        return null;
    }
    return (React.createElement(ProductPromotions, { products: products, promotionLabel: promotionLabel, supertitle: supertitle, title: title, staticsUrl: grandvision === null || grandvision === void 0 ? void 0 : grandvision.staticsUrl, formatProductUrl: formatProductUrl }));
};
var Promotion = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsPromotion);

var CmsRecentlyViewedProducts = function () {
    var _a;
    var publicRuntimeConfig = React.useContext(RuntimeContext);
    var _b = __read(useBloomreachProductRoutes(), 2); _b[0]; var formatProductUrl = _b[1].formatProductUrl;
    var siteLogos = useBloomreach().siteLogos;
    return (React.createElement(RecentlyViewedProducts$1, { reimbursableLogos: {
            default: siteLogos.reimbursable,
            alternative: siteLogos.reimbursableAlternative,
        }, formatProductUrl: formatProductUrl, staticsUrl: ((_a = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.grandvision) === null || _a === void 0 ? void 0 : _a.staticsUrl) || '' }));
};
var RecentlyViewedProducts = compose(withBreakpointVisibility, withAnchor)(CmsRecentlyViewedProducts);

/**
 * This variant of the Rich Text component is used on container (drag & drop) pages
 */
var CmsRichText = function (_a) {
    var _b;
    var page = _a.page, content = _a.content, meta = _a.meta, template = _a.template;
    var richText = useBloomreachRichText((_b = content.content) === null || _b === void 0 ? void 0 : _b.value);
    if (!richText) {
        return null;
    }
    switch (template) {
        case 'default':
            return (React.createElement(RichTextArea, { content: richText, textColor: meta.textColor, backgroundColor: meta.backgroundColor }));
        // Modal template is only added to be able to retrieve the content from the pageModel.
        case 'modal':
            return page.isPreview() ? React.createElement(RichTextArea, { content: richText }) : null;
        default:
            return (React.createElement(Heading$1, { variant: "subheading1" },
                "RichText component of type ",
                template,
                " not defined in RichTextCollection"));
    }
};
var RichText = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsRichText);

var CmsSeo = function () {
    var _a, _b;
    var _c = useBloomreach(), preview = _c.preview, pageSeo = _c.pageSeo;
    var algoliaInstantSearchProps = useAlgoliaConfig().algoliaInstantSearchProps;
    if (!pageSeo && !preview) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        preview && React.createElement("div", { style: { border: '2px solid black', padding: 10 } }, "SEO configuration"),
        pageSeo && (React.createElement(CmsHeadTags, __assign({}, pageSeo, { ogUrl: pageSeo.canonicalUrl, noFollow: pageSeo.nofollow, noIndex: pageSeo.noindex, ogImage: ((_a = pageSeo.image) === null || _a === void 0 ? void 0 : _a.url) || '', pageNr: (_b = algoliaInstantSearchProps.searchState.configure) === null || _b === void 0 ? void 0 : _b.page })))));
};

var defaultLayout = {
    header: true,
    footer: true,
    navigation: true,
};
var CmsPageLayout = function (_a) {
    var children = _a.children, _b = _a.layoutSettings, layoutSettings = _b === void 0 ? {} : _b, _c = _a.renderCartButton, renderCartButton = _c === void 0 ? defaultRenderCartButton : _c, _d = _a.isSolaris, isSolaris = _d === void 0 ? false : _d, _e = _a.useCookieBar, useCookieBar = _e === void 0 ? false : _e, useAlternativeLogoInFooter = _a.useAlternativeLogoInFooter;
    var layout = __assign(__assign({}, defaultLayout), layoutSettings);
    var header = layout.header ? (React.createElement(CmsComponentSlot, { path: "header" },
        React.createElement(CmsHeader, { isSolaris: isSolaris, renderSiteNav: layout.navigation, renderCartButton: renderCartButton }))) : null;
    var footer = layout.footer ? (React.createElement(CmsComponentSlot, { path: "footer" },
        React.createElement(CmsFooter, { useAlternativeLogoInFooter: useAlternativeLogoInFooter }))) : null;
    var cookieBar = useCookieBar ? (React.createElement(CmsComponentSlot, { path: "footer/cookie-consent" },
        React.createElement(CmsCookieNotification, null))) : null;
    return (React.createElement(PageLayout, { header: header, footer: footer, cookieBar: cookieBar, hasSiteNav: layout.navigation, isSolaris: isSolaris }, children));
};
function defaultRenderCartButton(item) {
    return (React.createElement(CartButton, { key: item.label, href: item.link && item.link.href, label: item.label, className: "header-menu__icon" }));
}

var CmsContentLayout = function (_a) {
    var content = _a.content, pageName = _a.pageName;
    var contentBlocks = content.contentBlocks, coverImage = content.coverImage, summary = content.summary, title = content.title, url = content.url;
    var image = parseBloomreachImage(coverImage);
    var isBrandPage = pageName === 'brand-detail';
    return (React.createElement("div", { className: classnames('content-layout', {
            'content-layout--brand': isBrandPage,
        }) },
        React.createElement(CmsContentBreadcrumbs, { url: url }),
        image && React.createElement(Banner, { useContainer: true, image: image.original, mobileImage: image.mobile }),
        title && (React.createElement(Heading$1, { variant: "large", className: "content-layout__title", align: isBrandPage ? 'center' : 'left' }, title)),
        summary && (React.createElement("div", { className: "content-layout__summary rich-text-area" },
            React.createElement(Text, { align: isBrandPage ? 'center' : 'left' }, summary))),
        React.createElement("article", { className: "content", id: "content-start" }, contentBlocks.length > 0 && React.createElement(CmsContentBlocks, { contentBlocks: contentBlocks }))));
};
var CmsContentLayout$1 = withEditableContent(CmsContentLayout);

var CmsBlogLayout = function (_a) {
    var content = _a.content;
    var _b = useIntl(), getLabel = _b.getLabel, locale = _b.locale;
    var title = content.title, summary = content.summary, coverImage = content.coverImage, publishDate = content.publishDate, readingTime = content.readingTime, contentBlocks = content.contentBlocks;
    var image = parseBloomreachImage(coverImage);
    return (React.createElement("div", { className: "blog-layout" },
        image && (React.createElement(BlogDetailHeader, { title: title, image: image.original, mobileImage: image.mobile, scrollTo: "blog-content-start" })),
        summary && (React.createElement(BlogIntro, { locale: locale, summary: summary, publishDate: publishDate, readingTime: readingTime, minutesLabel: getLabel('blog.minutesToRead') })),
        React.createElement("article", { className: "blog-content", id: "blog-content-start" }, contentBlocks.length > 0 && React.createElement(CmsContentBlocks, { contentBlocks: contentBlocks }))));
};
var CmsBlogLayout$1 = withEditableContent(CmsBlogLayout);

var isBlogArticle = function (content) {
    return content.type === 'blogArticle';
};
var ContentPageType = function () {
    var _a, _b;
    var pageSeo = useBloomreach().pageSeo;
    var page = useBrPageContext();
    var component = useBrComponentContext();
    var documentRef = ((_a = component === null || component === void 0 ? void 0 : component.getModels()) !== null && _a !== void 0 ? _a : {}).document;
    var pageName = (_b = page === null || page === void 0 ? void 0 : page.getComponent().getName()) !== null && _b !== void 0 ? _b : '';
    var document = page === null || page === void 0 ? void 0 : page.getContent(documentRef);
    var content = document === null || document === void 0 ? void 0 : document.getData();
    if (!content) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        document && React.createElement(BrManageContentButton, { content: document }),
        isBlogArticle(content) ? (React.createElement(CmsBlogLayout$1, { content: content })) : (React.createElement(CmsContentLayout$1, { content: content, pageName: pageName })),
        pageSeo && content && (React.createElement(WebPage, { pageType: "Information", url: pageSeo.canonicalUrl, name: content.title, description: content.summary }))));
};
var CmsContentPage = function (props) {
    var _a = useBloomreach(), pageModel = _a.pageModel, sdkConfig = _a.sdkConfig, pageSeo = _a.pageSeo;
    if (!sdkConfig) {
        console.warn("CmsContentPage: can't render without a valid Bloomreach SDK config. Got: " + sdkConfig);
        return null;
    }
    if (!pageModel) {
        console.warn("Tried to render CmsContainerPage without a valid Bloomreach PageModel: " + String(pageModel));
        return null;
    }
    return (React.createElement(BrPage, { configuration: sdkConfig, mapping: {}, page: pageModel },
        pageSeo && React.createElement(CmsSeo, null),
        React.createElement(CmsPageLayout, __assign({}, props),
            React.createElement(CmsComponentSlot, { path: "main/content" },
                React.createElement(ContentPageType, null)))));
};

var CmsContainerPage = function (_a) {
    var children = _a.children;
    var _b = useBloomreach(), _c = _b.componentDefinitions, componentDefinitions = _c === void 0 ? {} : _c, pageModel = _b.pageModel, sdkConfig = _b.sdkConfig, pageSeo = _b.pageSeo;
    if (!sdkConfig) {
        console.warn("Tried to render CmsContainerPage without a valid Bloomreach SDK configuration: " + String(sdkConfig));
        return null;
    }
    if (!pageModel) {
        console.warn("Tried to render CmsContainerPage without a valid Bloomreach PageModel: " + String(pageModel));
        return null;
    }
    return (React.createElement(BrPage, { configuration: sdkConfig, mapping: componentDefinitions, page: pageModel },
        children,
        pageSeo && (React.createElement(WebPage, { pageType: pageSeo.type, url: pageSeo.canonicalUrl, name: pageSeo.title, description: pageSeo.description }))));
};

var defaultComponentDefinitions = {
    Accordion: CmsAccordion$1,
    Article: Article,
    Banner: CmsBanner$1,
    'Banner collection': CmsBannerCollection$1,
    'Blog Collection': BlogCollection,
    'Blog Overview': BlogOverview,
    'Brand collection': BrandCollection,
    'Brand List': BrandList,
    Carousel: CmsCarousel$1,
    Document: Document,
    FAQ: Faq,
    Heading: Heading,
    'Icon-Link List': IconList,
    IFrame: CmsIframe$1,
    'Notification bar': NotificationBar,
    'Olapic Widget': Olapic,
    Page: CmsEmpty,
    'Policy bar': PolicyBar,
    'Product catalog v2': ProductCatalog,
    Promotion: Promotion,
    'Rich Text': RichText,
    Seo: CmsSeo,
    Translation: CmsAccordion$1,
    Video: CmsVideo$1,
    Widget: CmsWidget$1,
    'Recently viewed products': RecentlyViewedProducts,
};
function extendComponentDefinitions(definitionsToAdd) {
    return __assign(__assign({}, defaultComponentDefinitions), definitionsToAdd);
}

/**
 * This is in a separate module from BloomreachContext itself to avoid a
 * circular dependency between ../component-definitions and ../containers.
 * Do not re-export this from ./index
 */
function BloomreachProvider(_a) {
    var _b, _c;
    var settings = _a.settings, children = _a.children;
    var _d = settings.cmsUrls, cmsUrls = _d === void 0 ? initialValue.cmsUrls : _d, customComponentMap = settings.customComponentMap, _e = settings.componentDefinitions, componentDefinitions = _e === void 0 ? defaultComponentDefinitions : _e, disableUrlRewriter = settings.disableUrlRewriter, _f = settings.isMultilingualEnabled, isMultilingualEnabled = _f === void 0 ? false : _f, excludeSkuFromProductUrls = settings.excludeSkuFromProductUrls, pageModel = settings.pageModel, visitor = settings.visitor, path = settings.path;
    var preview = (_c = (_b = pageModel === null || pageModel === void 0 ? void 0 : pageModel._meta) === null || _b === void 0 ? void 0 : _b.preview) !== null && _c !== void 0 ? _c : false;
    var pageSeo = getPageSeo(pageModel);
    var sdkConfig = React.useMemo(function () {
        // Add locale to bloomreach urls for multilingual support (SDK doesn't accept it in the path)
        var locale = isMultilingualEnabled ? settings.locale : undefined;
        var urlLive = createBloomreachApiUrl(cmsUrls.live, locale);
        var urlPreview = createBloomreachApiUrl(cmsUrls.preview, locale);
        var parsedPath = createPath(path || '', locale);
        // The SDK accepts two types of URL configuration. Based on the passed configuration
        // it expects the URL rewriter to be enabled or disabled within the CMS
        var origin = (cmsUrls.preview ? new URL(cmsUrls.preview) : {}).origin;
        var urls = disableUrlRewriter
            ? { cmsBaseUrl: urlLive, origin: origin }
            : {
                options: {
                    live: { cmsBaseUrl: urlLive },
                    preview: { cmsBaseUrl: urlPreview },
                },
            };
        return __assign(__assign({}, urls), { visitor: visitor, request: { path: parsedPath }, httpClient: brHttpClient });
    }, [
        isMultilingualEnabled,
        settings.locale,
        cmsUrls.live,
        cmsUrls.preview,
        disableUrlRewriter,
        visitor,
        path,
    ]);
    var siteLogos = React.useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var models = (_b = (_a = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page) === null || _a === void 0 ? void 0 : _a.models) !== null && _b !== void 0 ? _b : {};
        return {
            main: (_c = models.logoUrl) !== null && _c !== void 0 ? _c : '',
            small: (_d = models.logoSmallUrl) !== null && _d !== void 0 ? _d : '',
            mobile: (_e = models.logoMobileUrl) !== null && _e !== void 0 ? _e : '',
            alternative: (_f = models.logoAlternativeUrl) !== null && _f !== void 0 ? _f : '',
            reimbursable: (_g = models.reimbursableLogoUrl) !== null && _g !== void 0 ? _g : '',
            reimbursableAlternative: (_h = models.reimbursableLogoAlternativeUrl) !== null && _h !== void 0 ? _h : '',
        };
    }, [pageModel]);
    var value = React.useMemo(function () {
        var val = __assign(__assign({}, initialValue), { componentDefinitions: componentDefinitions, cmsUrls: cmsUrls, customComponentMap: customComponentMap, disableUrlRewriter: disableUrlRewriter, excludeSkuFromProductUrls: excludeSkuFromProductUrls, pageModel: pageModel, preview: preview, path: path, siteLogos: siteLogos, sdkConfig: sdkConfig, pageSeo: pageSeo });
        return val;
    }, [
        componentDefinitions,
        cmsUrls,
        customComponentMap,
        disableUrlRewriter,
        excludeSkuFromProductUrls,
        pageModel,
        preview,
        path,
        siteLogos,
        sdkConfig,
        pageSeo,
    ]);
    return React.createElement(BloomreachContext.Provider, { value: value, children: children });
}

function getLabels(apiUrl, channel, resourceIds, locale) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, resources, labelSets, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = createBloomreachResourceUrl(apiUrl, channel, resourceIds, locale.replace('-', '_'));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, {
                            method: 'GET',
                            headers: { Accept: 'application/json' },
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    resources = _a.sent();
                    labelSets = flattenResources(resources);
                    return [2 /*return*/, mergeLabels(labelSets)];
                case 4:
                    err_1 = _a.sent();
                    console.error("Error while fetching labels for " + url, err_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}

function getPageModel(apiUrl, path, opts) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, headers, connection, visitor, disableUrlRewriter, cookies, request, origin, configuration;
        return __generator(this, function (_b) {
            _a = opts.headers, headers = _a === void 0 ? {} : _a, connection = opts.connection, visitor = opts.visitor, disableUrlRewriter = opts.disableUrlRewriter, cookies = opts.cookies;
            if (!apiUrl) {
                throw new Error("Need a valid Bloomreach api url to fetch a pageModel! Got: " + String(apiUrl));
            }
            if (!path) {
                throw new Error("Need a valid path to fetch a pageModel! Got: " + String(path));
            }
            // When the URL rewriter is enabled, we need to initialize the "legacy" way (BR < 14.2)
            if (!disableUrlRewriter) {
                return [2 /*return*/, legacyInitialize(apiUrl, path, cookies)];
            }
            request = {
                path: path,
                connection: connection,
                headers: __assign({}, (headers['x-forwarded-for'] ? { 'x-forwarded-for': headers['x-forwarded-for'] } : {})),
            };
            origin = new URL(apiUrl).origin;
            configuration = {
                cmsBaseUrl: apiUrl,
                origin: origin.replace('www', 'cms'),
                httpClient: brHttpClient,
                visitor: visitor,
                request: request,
            };
            if (process.env.NODE_ENV !== 'production') {
                console.log("Fetching: " + apiUrl + "/resourceapi" + path);
            }
            return [2 /*return*/, initialize(configuration)];
        });
    });
}
/**
 * The initialize function from the SDK does not support Bloomreach 14.0.0 and older.
 * Hence we need to do a plain fetch to the API when we're still using the old version
 * of bloomreach in combination with the URL rewriter.
 *
 * To avoid having to duplicate more code, we create an object that is similar to the object
 * that the "initialize" function from the SDK returns.
 */
function legacyInitialize(apiUrl, path, cookies) {
    return __awaiter(this, void 0, void 0, function () {
        var url, res, pageModel_1, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = apiUrl + "/resourceapi" + path;
                    if (process.env.NODE_ENV !== 'production') {
                        console.log("[Legacy] Fetching: " + url);
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, {
                            method: 'GET',
                            // To do the legacy api call in preview mode we need to forward the cookie string
                            // because bloomreach requires certain cookies to authenticate
                            headers: cookies !== undefined ? { Cookie: cookies } : {},
                        })];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    pageModel_1 = _a.sent();
                    return [2 /*return*/, {
                            toJSON: function () { return pageModel_1; },
                            getVisitor: function () { return undefined; },
                        }];
                case 4:
                    err_1 = _a.sent();
                    console.error("[Legacy] Failed to initialize pageModel.", err_1);
                    return [2 /*return*/, {}];
                case 5: return [2 /*return*/];
            }
        });
    });
}

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getLabels: getLabels,
    getPageModel: getPageModel
});

export { index as BloomreachApi, BloomreachProvider, CmsComponentSlot, CmsContainerPage, CmsContentPage, CmsCustomPackage, CmsFooter, CmsHeadTags, CmsHeader, CmsPageLayout, CmsProductBreadcrumbs, CmsSeo, RuntimeContext, VISITOR_COOKIE, createBloomreachApiUrl, createPath, extendComponentDefinitions, getAlgoliaConfigFromBloomreach, getPageTemplate, getPlpPromotionSize, parsePageModel, useBloomreach, useBloomreachPageRoutes, useBloomreachPdpContent, useBloomreachProductRoutes, useBloomreachSdpContent };
//# sourceMappingURL=index.es.js.map
